(function () {
  'use strict';

  var RDV_CFG = { startHour: 9, endHour: 19, stepMinutes: 30 };
  var WA_NUMBER = (window.ORA_CONFIG && window.ORA_CONFIG.whatsapp) ? String(window.ORA_CONFIG.whatsapp) : '33743765114';
  var TOTAL_STEPS = 7;
  var URGENCE_DEFAUT = 'Oui';
  var MAX_FREE = 200;
  var lastApiResult = null;
  var submitLock = false;
  var coachTimer = null;
  var preferReducedMotion = false;
  try {
    preferReducedMotion = !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
  } catch (eMotion) {}

  /* Messages contextuels — ton atelier premium, logique métier */
  var ORA_COACH = {
    step: {
      0: 'Indiquez le type de véhicule : cela oriente d’emblée le diagnostic.',
      1: 'Décrivez la panne : plus c’est précis, plus l’atelier anticipe le bon matériel.',
      2: 'Choisissez une préférence de créneau — nous la confirmons avec vous.',
      3: 'La marque et le modèle aident à préparer les pièces adaptées.',
      4: 'WhatsApp est souvent le canal le plus fluide pour photos et échanges.',
      5: 'Vos coordonnées permettent une prise en charge claire et sans ressaisie.',
      6: 'Vérifiez le récapitulatif : ensuite la demande est enregistrée à l’atelier.'
    },
    byKey: {
      engin: 'Indiquez le type de véhicule : cela oriente d’emblée le diagnostic.',
      probleme: 'Décrivez la panne : plus c’est précis, plus l’atelier anticipe le bon matériel.',
      rdv: 'Choisissez une préférence de créneau — nous la confirmons avec vous.',
      modele: 'La marque et le modèle aident à préparer les pièces adaptées.',
      contact: 'WhatsApp est souvent le canal le plus fluide pour photos et échanges.',
      coordonnees: 'Vos coordonnées permettent une prise en charge claire et sans ressaisie.',
      recap: 'Vérifiez le récapitulatif : ensuite la demande est enregistrée à l’atelier.'
    },
    engin: {
      'Trottinette électrique': 'Trottinette notée. Nous adaptons le diagnostic aux spécificités EDPM.',
      'Vélo électrique': 'Vélo électrique noté. Transmission, batterie et freinage seront pris en compte.',
      'Autre EDPM': 'EDPM noté. Précisez ensuite la panne : l’atelier affine le besoin.'
    },
    probleme: {
      'Pneu / crevaison': 'Intervention souvent possible à domicile — précisez la roue et le type de pneu.',
      'Freinage': 'Sécurité prioritaire. Les détails (levier, disque, type) accélèrent le diagnostic.',
      'Batterie / autonomie': 'Panne souvent traitée en atelier. Les symptômes aident à isoler la cause.',
      'Électronique': 'Diagnostic atelier recommandé. Un code erreur, s’il s’affiche, est très utile.',
      'Autre problème': 'Décrivez en quelques mots : depuis quand, et après quel événement.'
    },
    chips: {
      'roue|Avant': 'Roue avant notée.',
      'roue|Arrière': 'Roue arrière notée — souvent motorisée sur trottinette.',
      'roue|Les deux': 'Les deux roues notées : nous préparons une vérification complète.',
      'roue|Je ne sais pas': 'Pas de souci : une photo après l’envoi suffit souvent.',
      'motor|Oui': 'Roue motorisée : intervention plus technique, anticipée par l’atelier.',
      'motor|Non': 'Roue non motorisée : intervention généralement plus directe.',
      'motor|Je ne sais pas': 'Nous le vérifierons avec vous ou via une photo.',
      'pneu_type|Chambre à air': 'Chambre à air : réparation ou remplacement selon l’état.',
      'pneu_type|Tubeless': 'Tubeless noté — matériel adapté prévu.',
      'pneu_type|Pneu plein': 'Pneu plein : usure ou déformation à contrôler.',
      'pneu_type|Je ne sais pas': 'Le type sera confirmé à la prise en charge.',
      'frein_roue|Avant': 'Frein avant — élément critique pour la sécurité.',
      'frein_roue|Arrière': 'Frein arrière noté.',
      'frein_roue|Les deux': 'Les deux freins : contrôle sécurité complet recommandé.',
      'frein_symptome|Freine mal': 'Perte d’efficacité notée — priorité sécurité.',
      'frein_symptome|Bruit ou frottement': 'Bruit / frottement : plaquettes, disque ou réglage à vérifier.',
      'frein_symptome|Levier mou': 'Levier mou : souvent câble, purge ou usure.',
      'frein_symptome|Disque voilé': 'Disque voilé : contrôle et remplacement éventuel.',
      'frein_type|Mécanique': 'Frein mécanique noté.',
      'frein_type|Hydraulique': 'Frein hydraulique : diagnostic plus précis en atelier si besoin.',
      'bat_pb|Ne charge plus': 'Absence de charge : batterie, BMS ou chargeur à isoler.',
      'bat_pb|Tient moins la charge': 'Perte d’autonomie : usure ou cellule à contrôler.',
      'bat_pb|S\'éteint seul': 'Extinction spontanée : contact, BMS ou tension trop basse.',
      'bat_pb|Coupe en roulant': 'Coupure en roulant : souvent protection thermique ou connexion.',
      'bat_allume|Oui': 'Le véhicule s’allume : bonne base pour le diagnostic.',
      'bat_allume|Non': 'Pas d’allumage : priorité alimentation / batterie.',
      'bat_allume|Parfois': 'Allumage intermittent : à préciser avec photos si possible.',
      'bat_chargeur|Oui': 'Chargeur déjà testé — utile pour l’atelier.',
      'bat_chargeur|Non': 'Tester un autre chargeur peut parfois lever le doute.',
      'elec_sym|Écran éteint': 'Écran éteint : alimentation, connecteurs ou contrôleur.',
      'elec_sym|Code erreur': 'Indiquez le code affiché : cela oriente fortement le diagnostic.',
      'elec_sym|Accélérateur ne répond plus': 'Accélérateur : poignée, câblage ou contrôleur.',
      'elec_sym|Moteur ne tourne plus': 'Moteur silencieux : souvent atelier / enlèvement si immobilisé.',
      'elec_sym|Éclairage ou autre HS': 'Éclairage / accessoire : intervention ciblée.',
      'elec_cause|Après pluie': 'Après pluie : humidité possible sur connecteurs.',
      'elec_cause|Après choc ou chute': 'Après choc : contrôle structure et faisceaux.',
      'elec_cause|Sans raison apparente': 'Sans cause apparente : diagnostic méthodique atelier.',
      'elec_moteur|Oui': 'Le moteur répond encore — bon signe.',
      'elec_moteur|Non': 'Moteur sans réponse : prise en charge renforcée.',
      'elec_moteur|Par moments': 'Réponse intermittente : à documenter si possible.'
    },
    urgence: {
      'Oui': 'Véhicule encore utilisable : planification standard, sans urgence forcée.',
      'Difficilement': 'Usage difficile : nous organisons une prise en charge rapidement.',
      'Non, immobilisé': 'Véhicule immobilisé : enlèvement ou atelier souvent plus adaptés.'
    },
    contact: {
      'WhatsApp': 'WhatsApp choisi : idéal pour envoyer 1 à 3 photos après validation.',
      'Email': 'Email choisi : l’atelier vous répondra à l’adresse indiquée.'
    },
    zone: {
      OK: 'Secteur couvert. Les frais de déplacement suivent le barème Oratelier.',
      MANUAL: 'Zone à confirmer avec l’atelier — votre demande reste possible.',
      BLOCK: 'Hors zone domicile : une prise en charge à l’atelier reste envisageable.'
    }
  };

  var oraCoach = document.getElementById('oraCoach');
  var oraCoachText = document.getElementById('oraCoachText');
  var oraLivePath = document.getElementById('oraLivePath');

  function setCoach(message, tone) {
    if (!funnelActive) return;
    if (!oraCoach || !oraCoachText || !message) return;
    oraCoachText.textContent = message;
    oraCoach.hidden = false;
    oraCoach.classList.remove('ora-coach-info', 'ora-coach-warn', 'ora-coach-ok', 'ora-coach-pulse');
    oraCoach.classList.add(tone === 'warn' ? 'ora-coach-warn' : tone === 'ok' ? 'ora-coach-ok' : 'ora-coach-info');
    if (!preferReducedMotion) {
      void oraCoach.offsetWidth;
      oraCoach.classList.add('ora-coach-pulse');
    }
    if (coachTimer) clearTimeout(coachTimer);
  }

  function setCoachForStep(stepIndex) {
    if (!funnelActive) return;
    var step = steps[stepIndex];
    var key = stepKey_(step);
    var msg = (key && ORA_COACH.byKey[key]) || ORA_COACH.step[stepIndex];
    if (msg) setCoach(msg, 'info');
  }

  function stepKey_(step) {
    if (!step) return '';
    var key = step.getAttribute('data-key') || '';
    if (key) return key;
    if (step.id === 'oraStepPrise' || step.querySelector('#oraPriseAtelier')) return 'prise';
    if (step.querySelector('.ora-problem-main') || step.querySelector('#oraProblemeContinue')) return 'probleme';
    if (step.querySelector('#oraDateInput')) return 'rdv';
    if (step.querySelector('#oraModelInput')) return 'modele';
    if (step.querySelector('#oraPrenomInput')) return 'coordonnees';
    if (step.querySelector('#oraSummaryList')) return 'recap';
    return '';
  }

  function isUrgenceStep_(step) {
    if (!step) return false;
    if (step.getAttribute('data-key') === 'urgence') return true;
    return !!(
      step.querySelector('.ora-option[data-value="Non, immobilisé"]') &&
      step.querySelector('.ora-option[data-value="Oui"]') &&
      step.querySelector('.ora-option[data-value="Difficilement"]')
    );
  }

  function ensureUrgenceDefault_() {
    if (!answers.urgence) answers.urgence = URGENCE_DEFAUT;
  }

  function refreshSteps_() {
    steps = Array.prototype.slice.call(document.querySelectorAll('.ora-step')).filter(function (s) {
      return !s.hasAttribute('data-ora-removed');
    });
    TOTAL_STEPS = steps.length || 1;
  }

  /** Étape « état du véhicule » retirée du parcours (valeur par défaut). */
  function removeUrgenceStep_() {
    var all = document.querySelectorAll('.ora-step');
    for (var i = 0; i < all.length; i++) {
      if (!isUrgenceStep_(all[i])) continue;
      all[i].setAttribute('data-ora-removed', '1');
      all[i].hidden = true;
      all[i].classList.remove('ora-active');
      all[i].style.display = 'none';
    }
    refreshSteps_();
    ensureUrgenceDefault_();
  }

  function problemeStepIndex_() {
    for (var i = 0; i < steps.length; i++) {
      if (stepKey_(steps[i]) === 'probleme') return i;
    }
    return 1;
  }

  function updateLivePath() {
    if (!oraLivePath) return;
    var bits = [];
    if (answers.engin) bits.push(answers.engin);
    if (answers.probleme_main) bits.push(answers.probleme_main);
    if (answers.modele && answers.modele !== 'Non précisé') bits.push(answers.modele);
    if (answers.prise_en_charge_label) bits.push(answers.prise_en_charge_label);
    else if (answers.probleme_main) {
      var rec = recommendPriseEnCharge(answers.probleme_main, answers.urgence);
      if (rec) bits.push(rec);
    }
    if (!bits.length) {
      oraLivePath.innerHTML = '';
      oraLivePath.hidden = true;
      return;
    }
    oraLivePath.innerHTML = bits.map(function (b, i) {
      var cls = 'ora-path-chip' + (i === bits.length - 1 ? ' ora-path-current' : '');
      return '<span class="' + cls + '">' + escapeHtml(b) + '</span>';
    }).join('');
    oraLivePath.hidden = false;
  }

  function recommendPriseEnCharge(categorie, urgence) {
    var c = String(categorie || '').toLowerCase();
    var immo = urgence === 'Non, immobilisé';
    if (c.indexOf('batterie') !== -1 || c.indexOf('électron') !== -1 || c.indexOf('electron') !== -1) {
      return immo ? 'Enlèvement recommandé' : 'Atelier recommandé';
    }
    if (c.indexOf('pneu') !== -1 || c.indexOf('frein') !== -1) return 'Domicile souvent possible';
    if (immo) return 'Enlèvement envisageable';
    return '';
  }

  var PRISE_CHOIX_ = {
    atelier: { key: 'atelier', label: 'Dépôt atelier' },
    domicile: { key: 'domicile', label: 'Intervention domicile' },
    enlevement: { key: 'enlevement', label: 'Enlèvement / récupération' }
  };

  function appliquerPriseChoix_(choix) {
    var c = PRISE_CHOIX_[choix];
    if (!c) return false;
    answers.prise_en_charge_key = c.key;
    answers.prise_en_charge_label = c.label;
    return true;
  }

  function besoinAdressePrise_() {
    var k = answers.prise_en_charge_key || '';
    return k === 'domicile' || k === 'enlevement';
  }

  /** Étape explicite Atelier / Domicile (injectée avant le créneau). */
  function ensurePriseStep_() {
    if (document.getElementById('oraStepPrise')) {
      refreshSteps_();
      return;
    }
    var funnel = document.getElementById('oraFunnel') || document.querySelector('.ora-funnel');
    if (!funnel) return;
    var rdvStep = null;
    var all = funnel.querySelectorAll('.ora-step');
    for (var i = 0; i < all.length; i++) {
      if (stepKey_(all[i]) === 'rdv') { rdvStep = all[i]; break; }
    }
    var step = document.createElement('div');
    step.className = 'ora-step';
    step.id = 'oraStepPrise';
    step.setAttribute('data-key', 'prise');
    step.hidden = true;
    var rec = recommendPriseEnCharge(answers.probleme_main, answers.urgence);
    step.innerHTML =
      '<p class="ora-ex-lead">Où souhaitez-vous la prise en charge ?</p>' +
      (rec ? '<p class="ora-ex-hint" id="oraPriseHint">Suggestion : ' + escapeHtml(rec) + ' — vous choisissez.</p>' : '') +
      '<div class="ora-ex-stack" style="margin-top:.75rem">' +
        '<button type="button" class="ora-ex-choice ora-prise-btn" id="oraPriseAtelier" data-prise="atelier">À l’atelier — dépôt / retrait</button>' +
        '<button type="button" class="ora-ex-choice ora-prise-btn" id="oraPriseDomicile" data-prise="domicile">À domicile — intervention sur place</button>' +
        '<button type="button" class="ora-ex-choice ora-prise-btn" id="oraPriseEnlevement" data-prise="enlevement">Enlèvement — on récupère le véhicule</button>' +
      '</div>' +
      '<p id="oraPriseError" class="ora-acompte-error" hidden></p>';
    if (rdvStep && rdvStep.parentNode) rdvStep.parentNode.insertBefore(step, rdvStep);
    else funnel.appendChild(step);

    step.querySelectorAll('.ora-prise-btn').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var choix = btn.getAttribute('data-prise');
        if (!appliquerPriseChoix_(choix)) return;
        step.querySelectorAll('.ora-prise-btn').forEach(function (b) {
          b.classList.toggle('ora-selected', b === btn);
          b.setAttribute('aria-pressed', b === btn ? 'true' : 'false');
        });
        var err = document.getElementById('oraPriseError');
        if (err) { err.hidden = true; err.textContent = ''; }
        setCoach(
          choix === 'domicile'
            ? 'Intervention à domicile notée — adresse et zone vérifiées ensuite.'
            : (choix === 'enlevement'
              ? 'Enlèvement noté — adresse de récupération demandée ensuite.'
              : 'Dépôt atelier noté — créneau de passage ensuite.'),
          'ok'
        );
        trackEvent('prise_en_charge_chosen', { key: choix });
        updateLivePath();
        setTimeout(function () { advanceFromCurrent_(); }, preferReducedMotion ? 80 : 220);
      });
    });
    refreshSteps_();
  }

  function insightDelay() {
    return preferReducedMotion ? 120 : 480;
  }

  // Analytics hook (future-proof): safe no-op when no tracker is installed.
  function trackEvent(eventName, params) {
    if (!eventName) return;
    try {
      if (window.gtag && typeof window.gtag === 'function') {
        window.gtag('event', eventName, params || {});
        return;
      }
      if (window.dataLayer && typeof window.dataLayer.push === 'function') {
        window.dataLayer.push(Object.assign({ event: eventName }, params || {}));
      }
    } catch (eTrack) {}
  }

  function stripControlChars(s) { return s.replace(/[\u0000-\u0008\u000B\u000C\u000E-\u001F\u007F]/g, ''); }
  function sanitizeInput(input) {
    if (typeof input !== 'string') return '';
    var t = stripControlChars(String(input));
    try { if (typeof t.normalize === 'function') t = t.normalize('NFKC'); } catch (e) {}
    var div = document.createElement('div');
    div.textContent = t;
    var out = div.innerHTML.replace(/[<>]/g, '');
    if (out.length > 500) out = out.substring(0, 500);
    return out.trim();
  }
  function escapeHtml(text) { var div = document.createElement('div'); div.textContent = text || ''; return div.innerHTML; }
  var FREE_TEXT_SAFE = /^[a-zA-Z0-9\s\u00C0-\u024F.,;:!?'"()\-\/%&+=€@#*_]+$/;
  function validateFreeText(s, maxLen) {
    if (typeof s !== 'string' || !s.length) return true;
    var c = sanitizeInput(s);
    if (c.length > (maxLen || MAX_FREE)) return false;
    if (!FREE_TEXT_SAFE.test(c)) return false;
    if (/[<>{}[\]\\]/.test(c)) return false;
    return !containsDangerousPatterns(c);
  }
  function validateInput(input, type) {
    if (!input || typeof input !== 'string') return false;
    var cleaned = sanitizeInput(input);
    if (!cleaned) return false;
    switch (type) {
      case 'email': return /^[a-zA-Z0-9._%+\u00C0-\u017F-]+@[a-zA-Z0-9.\u00C0-\u017F-]+\.[a-zA-Z\u00C0-\u017F]{2,}$/.test(cleaned) && cleaned.length <= 254;
      case 'phone': return /^\+?[0-9]{10,15}$/.test(cleaned.replace(/[^0-9+]/g, ''));
      case 'text': return cleaned.length >= 1 && cleaned.length <= 200 && validateFreeText(cleaned, 200);
      case 'model': return cleaned.length <= 100 && !/[<>{}[\]\\]/.test(cleaned) && !containsDangerousPatterns(cleaned);
      default: return cleaned.length > 0;
    }
  }
  function sanitizeForPayload(input) { return typeof input === 'string' ? input.replace(/['";\\]/g, '').replace(/--/g, '').replace(/\/\*/g, '').replace(/\*\//g, '') : ''; }
  function containsDangerousPatterns(input) {
    if (typeof input !== 'string') return false;
    var dangerous = [/<script/i,/javascript:/i,/on\w+\s*=/i,/<iframe/i,/<object/i,/<embed/i,/data:text\/html/i,/vbscript:/i,/expression\(/i,/<svg/i,/onload/i,/onerror/i];
    for (var i=0;i<dangerous.length;i++) if (dangerous[i].test(input)) return true;
    return false;
  }
  function isValidZipFR(zip) { return /^[0-9]{5}$/.test((zip||'').toString().trim()); }

  var submitAttempts = 0, lastSubmitTime = 0, RATE_LIMIT_MS = 5000, MAX_ATTEMPTS = 5;
  function checkRateLimit() { var now = Date.now(); return !(now - lastSubmitTime < RATE_LIMIT_MS || submitAttempts >= MAX_ATTEMPTS); }

  var steps = Array.prototype.slice.call(document.querySelectorAll('.ora-step'));
  var answers = {};
  var currentStep = 0;
  var funnelActive = false;
  var draftRestored = false;

  function persistDraft_() {
    var api = window.OraRepairApi;
    if (!api || !api.saveDraft) return;
    try {
      api.saveDraft({
        answers: answers,
        step: currentStep,
        funnelActive: funnelActive,
        formulaire_version: 'v2'
      });
    } catch (eDraft) {}
  }

  function ensureNomField_() {
    if (document.getElementById('oraNomInput')) return document.getElementById('oraNomInput');
    var prenom = document.getElementById('oraPrenomInput');
    if (!prenom || !prenom.parentNode) return null;
    var wrap = document.createElement('label');
    wrap.className = prenom.parentNode.className || '';
    wrap.setAttribute('for', 'oraNomInput');
    wrap.innerHTML = 'Nom <span aria-hidden="true">*</span><br>';
    var input = document.createElement('input');
    input.type = 'text';
    input.id = 'oraNomInput';
    input.name = 'ora_nom';
    input.maxLength = 60;
    input.autocomplete = 'family-name';
    input.setAttribute('aria-required', 'true');
    if (prenom.className) input.className = prenom.className;
    wrap.appendChild(input);
    var parent = prenom.parentNode;
    if (parent.parentNode && parent.tagName && parent.tagName.toLowerCase() === 'label') {
      parent.parentNode.insertBefore(wrap, parent.nextSibling);
    } else {
      parent.insertBefore(wrap, prenom.nextSibling);
    }
    return input;
  }
  var selectedProblemeMain = '';

  var oraFunnel = document.getElementById('oraFunnel');
  var formMeta = document.getElementById('oraFormMeta');
  var progressText = document.getElementById('oraProgressText');
  var btnPrev = document.getElementById('oraBtnPrev');
  var problemeContinue = document.getElementById('oraProblemeContinue');
  var problemeStepError = document.getElementById('oraProblemeStepError');

  var detailPanels = {
    'Pneu / crevaison': document.getElementById('oraDetailsPneu'),
    'Freinage': document.getElementById('oraDetailsFrein'),
    'Batterie / autonomie': document.getElementById('oraDetailsBat'),
    'Électronique': document.getElementById('oraDetailsElec'),
    'Autre problème': document.getElementById('oraDetailsAutre')
  };

  function updateProgress() {
    if (formMeta) formMeta.hidden = !funnelActive;
    if (progressText) progressText.textContent = 'Étape ' + (currentStep + 1) + ' sur ' + TOTAL_STEPS;
    var fill = document.getElementById('oraProgressFill');
    var track = document.getElementById('oraProgressTrack');
    var pct = Math.round(((currentStep + 1) / TOTAL_STEPS) * 100);
    if (fill) fill.style.width = pct + '%';
    if (track) {
      track.setAttribute('aria-valuenow', String(currentStep + 1));
      track.setAttribute('aria-valuemax', String(TOTAL_STEPS));
    }
    if (btnPrev) {
      btnPrev.hidden = currentStep <= 0;
      btnPrev.disabled = currentStep <= 0;
    }
  }

  function syncPersistedStepOptions(stepIndex) {
    var step = steps[stepIndex];
    if (!step) return;
    var key = step.getAttribute('data-key');
    if (!key || !answers[key]) return;
    var val = answers[key];
    var opts = step.querySelectorAll('.ora-option[data-value]');
    for (var oi = 0; oi < opts.length; oi++) {
      var ob = opts[oi];
      var on = ob.getAttribute('data-value') === val;
      ob.classList.toggle('ora-selected', on);
      ob.setAttribute('aria-pressed', on ? 'true' : 'false');
    }
  }

  function scrollActiveIntoView(i) {
    if (!funnelActive) return;
    var active = steps[i];
    if (!active) return;
    try {
      active.scrollIntoView({
        behavior: preferReducedMotion ? 'auto' : 'smooth',
        block: 'start',
        inline: 'nearest'
      });
    } catch (eScroll) {
      try { active.scrollIntoView(true); } catch (e2) {}
    }
  }

  function showStep(i) {
    if (i < 0) i = 0;
    if (i >= steps.length) i = steps.length - 1;
    currentStep = i;
    for (var j = 0; j < steps.length; j++) steps[j].classList.toggle('ora-active', j === i);
    syncPersistedStepOptions(i);
    if (i === steps.length - 1) renderSummary();
    updateProgress();
    if (funnelActive) {
      updateLivePath();
      setCoachForStep(i);
      scrollActiveIntoView(i);
    }
    var pbIdx = problemeStepIndex_();
    if (i === pbIdx) updateProblemeContinueState();
    setTimeout(function () {
      var active = steps[i];
      if (!active) return;
      if (i === pbIdx) return;
      var first = active.querySelector('input:not([type="hidden"]), select, textarea, button[type="button"]:not([disabled]):not(#oraBtnPrev)');
      if (first && !first.disabled) {
        try { first.focus({ preventScroll: true }); }
        catch (eFocus) { first.focus(); }
      }
    }, preferReducedMotion ? 40 : 380);
  }

  function clearCompleteFrom(fromIndex){ for (var j=fromIndex;j<steps.length;j++) steps[j].classList.remove('ora-complete'); }
  function nextStepIndex_(from) {
    var n = from + 1;
    while (n < steps.length && answers.express) {
      var k = stepKey_(steps[n]);
      if (k === 'engin' || k === 'probleme' || k === 'modele' || k === 'urgence') { n++; continue; }
      break;
    }
    return n;
  }
  function advanceStep(i){
    var s = steps[i];
    if (s) s.classList.add('ora-complete');
    trackEvent('repair_step_validated', {
      step_index: i,
      step_key: s ? (stepKey_(s) || s.getAttribute('data-key') || 'recap') : 'unknown'
    });
    updateLivePath();
    persistDraft_();
    var next = nextStepIndex_(i);
    setTimeout(function(){ showStep(next); }, insightDelay());
  }
  function advanceFromCurrent_() {
    advanceStep(currentStep);
  }
  function goBack(){
    if (currentStep<=0) {
      if (answers.express) {
        var welcomeEl = document.getElementById('oraWelcome');
        var box = document.getElementById('oraExpressBox');
        if (oraFunnel) oraFunnel.setAttribute('hidden', 'hidden');
        if (welcomeEl) {
          welcomeEl.removeAttribute('hidden');
          welcomeEl.setAttribute('aria-hidden', 'false');
        }
        if (box) box.hidden = false;
        funnelActive = false;
        if (oraCoach) oraCoach.hidden = true;
      }
      return;
    }
    if (answers.express && stepKey_(steps[currentStep]) === 'rdv') {
      clearCompleteFrom(0);
      var welcomeEl2 = document.getElementById('oraWelcome');
      var box2 = document.getElementById('oraExpressBox');
      if (oraFunnel) oraFunnel.setAttribute('hidden', 'hidden');
      if (welcomeEl2) {
        welcomeEl2.removeAttribute('hidden');
        welcomeEl2.setAttribute('aria-hidden', 'false');
      }
      if (box2) box2.hidden = false;
      funnelActive = false;
      if (oraCoach) oraCoach.hidden = true;
      return;
    }
    var prev = currentStep - 1;
    while (prev > 0 && answers.express) {
      var pk = stepKey_(steps[prev]);
      if (pk === 'engin' || pk === 'probleme' || pk === 'modele' || pk === 'urgence') { prev--; continue; }
      break;
    }
    clearCompleteFrom(prev);
    showStep(prev);
  }

  function resetField(inp){ if (inp) inp.classList.remove('ora-input-error','ora-success'); }
  function markError(inp){ if (inp) inp.classList.add('ora-input-error'); }
  function markSuccess(inp){ if (inp) inp.classList.add('ora-success'); }

  var oraZoneCard = document.getElementById('oraZoneCard');
  var oraZoneText = document.getElementById('oraZoneText');
  var ZONE_OK = new Set(['77','91','45','89']);
  var ZONE_MANUAL = new Set(['94','92','93','78','10','51','28','02','60','95']);
  function isDomTom(dep){ return dep==='97'||dep==='98'; }
  function zoneDecisionFromZip(zip){
    var z=(zip||'').trim();
    if (!/^[0-9]{5}$/.test(z)) return { level:'INVALID', dep:'', msg:'Code postal invalide (5 chiffres).' };
    var dep=z.slice(0,2);
    if (isDomTom(dep)) return { level:'BLOCK', dep:dep, msg:'Hors zone (70 km max autour de 77250).' };
    if (ZONE_OK.has(dep)) return { level:'OK', dep:dep, msg:'' };
    if (ZONE_MANUAL.has(dep)) return { level:'MANUAL', dep:dep, msg:'Zone à confirmer avec l’atelier.' };
    return { level:'BLOCK', dep:dep, msg:'Hors zone (70 km max autour de 77250).' };
  }
  function renderZoneCard(dec){
    if (!oraZoneCard || !oraZoneText) return;
    oraZoneCard.classList.remove('ora-show','ora-zone-manual','ora-zone-block');
    if (!dec || dec.level==='OK') {
      oraZoneText.textContent='';
      if (dec && dec.level==='OK') {
        oraZoneCard.classList.add('ora-show');
        var feeTxt = 'Frais de déplacement à confirmer.';
        if (dec.travel_fee === 0 || dec.travel_fee === '0') feeTxt = 'Pas de frais de déplacement pour un dépôt atelier.';
        else if (dec.travel_fee != null && dec.travel_fee !== '') feeTxt = 'Frais de déplacement estimés : ' + dec.travel_fee + ' € (distance routière aller-retour).';
        else if (dec.message) feeTxt = dec.message;
        oraZoneText.textContent = 'Votre secteur est couvert. ' + feeTxt;
        setCoach(ORA_COACH.zone.OK, 'ok');
      }
      return;
    }
    oraZoneCard.classList.add('ora-show');
    if (dec.level==='MANUAL'){
      oraZoneCard.classList.add('ora-zone-manual');
      oraZoneText.textContent=dec.msg;
      setCoach(ORA_COACH.zone.MANUAL, 'warn');
    } else {
      oraZoneCard.classList.add('ora-zone-block');
      oraZoneText.textContent=dec.msg;
      setCoach(ORA_COACH.zone.BLOCK, 'warn');
    }
  }

  function hideAllDetailPanels(){ for (var k in detailPanels){ if (detailPanels[k]) { detailPanels[k].hidden=true; detailPanels[k].classList.remove('ora-visible'); } } }
  function clearChipsIn(panelEl){ if (!panelEl) return; var chips=panelEl.querySelectorAll('.ora-chip'); for (var i=0;i<chips.length;i++) chips[i].classList.remove('ora-chip-on'); }
  function updateProblemeContinueState(){ if (problemeContinue) problemeContinue.disabled=!selectedProblemeMain; }

  function onSelectProblemeMain(value){
    selectedProblemeMain=value; answers.probleme_main=value; hideAllDetailPanels();
    var p=detailPanels[value];
    if (p){ p.hidden=false; p.classList.add('ora-visible'); clearChipsIn(p); }
    var mains=document.querySelectorAll('.ora-problem-main');
    for (var i=0;i<mains.length;i++) {
      var on = mains[i].getAttribute('data-value')===value;
      mains[i].classList.toggle('ora-selected', on);
      mains[i].setAttribute('aria-pressed', on ? 'true' : 'false');
    }
    answers.probleme_precision={};
    var codeBlock=document.getElementById('oraElecCodeBlock');
    var codeInput=document.getElementById('oraCodeErreur');
    if (codeBlock) codeBlock.hidden = true;
    if (codeInput) codeInput.value = '';
    if (problemeStepError) problemeStepError.textContent='';
    var tip = ORA_COACH.probleme[value];
    if (tip) setCoach(tip, value.indexOf('Batterie')===0 || value.indexOf('Électronique')===0 ? 'warn' : 'ok');
    trackEvent('problem_selected', { problem_type: value });
    updateProblemeContinueState();
    updateLivePath();
  }

  document.querySelectorAll('.ora-problem-main').forEach(function(btn){
    btn.addEventListener('click', function(){
      var v=this.getAttribute('data-value');
      if (!v || containsDangerousPatterns(v)) return;
      onSelectProblemeMain(sanitizeInput(v));
    });
  });

  document.querySelectorAll('.ora-details-wrap').forEach(function(wrap){
    wrap.addEventListener('click', function(e){
      var chip=e.target.closest('.ora-chip');
      if (!chip || !wrap.contains(chip)) return;
      var group=chip.parentElement;
      if (!group || !group.getAttribute('data-field')) return;
      var field=group.getAttribute('data-field');
      var val=chip.getAttribute('data-value');
      if (!val || containsDangerousPatterns(val)) return;
      var siblings=group.querySelectorAll('.ora-chip');
      for (var i=0;i<siblings.length;i++) {
        siblings[i].classList.remove('ora-chip-on');
        siblings[i].setAttribute('aria-pressed', 'false');
      }
      chip.classList.add('ora-chip-on');
      chip.setAttribute('aria-pressed', 'true');
      if (!answers.probleme_precision) answers.probleme_precision={};
      answers.probleme_precision[field]=sanitizeInput(val);

      var codeBlock=document.getElementById('oraElecCodeBlock');
      if (field === 'elec_sym' && codeBlock) {
        var showCode = val === 'Code erreur';
        codeBlock.hidden = !showCode;
        if (showCode) {
          setCoach(ORA_COACH.chips['elec_sym|Code erreur'], 'warn');
          var ci = document.getElementById('oraCodeErreur');
          if (ci) setTimeout(function(){ ci.focus(); }, 180);
        }
      }

      var tipKey = field + '|' + val;
      var tip = ORA_COACH.chips[tipKey];
      if (tip && !(field === 'elec_sym' && val === 'Code erreur')) setCoach(tip, 'ok');
      updateLivePath();
    });
  });

  var codeErreurInput = document.getElementById('oraCodeErreur');
  if (codeErreurInput) {
    codeErreurInput.addEventListener('input', function(){
      var v = sanitizeInput(codeErreurInput.value);
      if (!answers.probleme_precision) answers.probleme_precision = {};
      if (v) {
        answers.probleme_precision.code_erreur = v;
        answers.code_erreur = v;
        setCoach('Code « ' + v + ' » noté — très utile pour le diagnostic atelier.', 'ok');
      } else {
        delete answers.probleme_precision.code_erreur;
        answers.code_erreur = '';
      }
    });
  }

  function bindCharCount(textareaId, spanId){
    var ta=document.getElementById(textareaId), sp=document.getElementById(spanId);
    if (!ta || !sp) return;
    function upd(){ sp.textContent=String(ta.value.length); }
    ta.addEventListener('input',upd); upd();
  }
  bindCharCount('oraNotePneu','oraCntPneu');
  bindCharCount('oraNoteFrein','oraCntFrein');
  bindCharCount('oraNoteBat','oraCntBat');
  bindCharCount('oraNoteElec','oraCntElec');
  bindCharCount('oraNoteAutre','oraCntAutre');

  function collectNoteForPanel(main){
    var id=main==='Pneu / crevaison'?'oraNotePneu':main==='Freinage'?'oraNoteFrein':main==='Batterie / autonomie'?'oraNoteBat':main==='Électronique'?'oraNoteElec':main==='Autre problème'?'oraNoteAutre':null;
    var el=id?document.getElementById(id):null;
    return el?el.value.trim():'';
  }
  function requiredChipFieldsFor(main){
    if (main==='Pneu / crevaison') return ['roue','motor','pneu_type'];
    if (main==='Freinage') return ['frein_roue','frein_symptome','frein_type'];
    if (main==='Batterie / autonomie') return ['bat_pb','bat_allume','bat_chargeur'];
    if (main==='Électronique') return ['elec_sym','elec_cause','elec_moteur'];
    return [];
  }

  function validateProblemeStep(){
    if (problemeStepError) problemeStepError.textContent='';
    if (!selectedProblemeMain){ if (problemeStepError) problemeStepError.textContent='Sélectionnez un type de panne.'; return false; }
    var noteRaw=collectNoteForPanel(selectedProblemeMain);
    if (noteRaw && !validateFreeText(noteRaw,MAX_FREE)){ if (problemeStepError) problemeStepError.textContent='Précision utile : caractères non autorisés ou texte trop long.'; return false; }
    if (containsDangerousPatterns(noteRaw)){ if (problemeStepError) problemeStepError.textContent='Texte invalide.'; return false; }
    if (selectedProblemeMain==='Autre problème'){
      if (!noteRaw){ if (problemeStepError) problemeStepError.textContent='Décrivez la panne en quelques mots.'; return false; }
      var sn=sanitizeInput(noteRaw);
      answers.probleme_notes=sn;
      answers.probleme='Autre problème : ' + sn;
      answers.probleme_precision={};
      attachPrestationDemandee_();
      return true;
    }
    var req=requiredChipFieldsFor(selectedProblemeMain), prec=answers.probleme_precision||{};
    for (var i=0;i<req.length;i++){ if (!prec[req[i]]){ if (problemeStepError) problemeStepError.textContent='Une réponse par ligne de précision.'; return false; } }
    answers.probleme_notes=noteRaw?sanitizeInput(noteRaw):'';
    answers.probleme=buildProblemeSummaryLine();
    attachPrestationDemandee_();
    return true;
  }

  function attachPrestationDemandee_() {
    var label = answers.prestation_demandee;
    if (!label) return;
    var cur = String(answers.probleme || '');
    if (cur.indexOf(label) === -1) answers.probleme = cur ? (cur + ' · ' + label) : label;
  }

  function buildProblemeSummaryLine(){
    var main=selectedProblemeMain || answers.probleme_main || '';
    var p=answers.probleme_precision || {}, parts=[main], order=requiredChipFieldsFor(main);
    for (var i=0;i<order.length;i++) if (p[order[i]]) parts.push(p[order[i]]);
    if (answers.probleme_notes) parts.push(answers.probleme_notes);
    return parts.join(' · ');
  }

  function buildProblemeDetailBlockWA(){
    var main=answers.probleme_main || '', p=answers.probleme_precision || {}, lines=[];
    lines.push('Problème principal : ' + sanitizeForPayload(main));
    if (main==='Autre problème'){ lines.push('Détail : ' + sanitizeForPayload(answers.probleme_notes || '')); return lines.join('\n'); }
    var labels={roue:'Roue',motor:'Roue motorisée',pneu_type:'Type pneu',frein_roue:'Frein',frein_symptome:'Symptôme',frein_type:'Type frein',bat_pb:'Symptôme batterie',bat_allume:'Allumage',bat_chargeur:'Chargeur testé',elec_sym:'Symptôme élec.',elec_cause:'Cause probable',elec_moteur:'Moteur répond'};
    var order=requiredChipFieldsFor(main);
    for (var i=0;i<order.length;i++){ var k=order[i]; if (p[k] && labels[k]) lines.push(labels[k] + ' : ' + sanitizeForPayload(p[k])); }
    if (answers.probleme_notes) lines.push('Précision : ' + sanitizeForPayload(answers.probleme_notes));
    return lines.join('\n');
  }

  if (problemeContinue) problemeContinue.addEventListener('click', function(){
    if (!validateProblemeStep()) return;
    ensureUrgenceDefault_();
    ensurePriseStep_();
    var tip = recommendPriseEnCharge(selectedProblemeMain, answers.urgence);
    var hint = document.getElementById('oraPriseHint');
    if (hint && tip) hint.textContent = 'Suggestion : ' + tip + ' — vous choisissez.';
    if (tip) setCoach('Panne bien décrite. Ensuite : atelier ou domicile ? (suggestion : ' + tip + ')', 'ok');
    else setCoach('Panne enregistrée. Ensuite : atelier ou domicile ?', 'ok');
    advanceFromCurrent_();
  });

  function openFunnel(startKey){
    funnelActive=true;
    removeUrgenceStep_();
    ensureUrgenceDefault_();
    ensurePriseStep_();
    var welcomeEl=document.getElementById('oraWelcome');
    if (welcomeEl){ welcomeEl.setAttribute('hidden','hidden'); welcomeEl.setAttribute('aria-hidden','true'); }
    if (oraFunnel) oraFunnel.removeAttribute('hidden');
    if (oraCoach) oraCoach.hidden = false;
    updateProgress();
    if (startKey) {
      var idx = stepIndexByKeyName_(startKey);
      if (idx < 0) idx = 0;
      for (var i = 0; i < idx; i++) {
        if (steps[i]) steps[i].classList.add('ora-complete');
      }
      showStep(idx);
    } else {
      showStep(0);
    }
    setCoach('Parcours guidé : chaque réponse aide l’atelier à préparer votre prise en charge.', 'info');
    trackEvent('repair_form_start', { source: startKey ? 'express_continue' : 'hero_primary_cta' });
  }

  function openFunnelAtKey_(keyName) {
    openFunnel(keyName);
  }

  var welcomeStart=document.getElementById('oraWelcomeStart');
  if (welcomeStart) welcomeStart.addEventListener('click', function(){ openFunnel(); });

  if (typeof window.location!=='undefined' && window.location.hash==='#oraFormMain') openFunnel();

  var quickWA=document.getElementById('oraQuickWA');
  if (quickWA){
    var waPre="Bonjour Oratelier,\n\nJe souhaite une prise en charge.\n\nVéhicule :\nPanne :\nCréneau souhaité :\nAdresse :\n\nJe peux envoyer 1 à 3 photos sur demande.";
    function refreshQuickWaHref(){ try { quickWA.href='https://wa.me/'+WA_NUMBER+'?text='+encodeURIComponent(waPre); } catch(eWa){ quickWA.href='https://wa.me/'+WA_NUMBER; } }
    refreshQuickWaHref();
    quickWA.addEventListener('pointerdown', refreshQuickWaHref);
    quickWA.addEventListener('focus', refreshQuickWaHref);
    // Tracking point: click on secondary hero WhatsApp link.
    quickWA.addEventListener('click', function(){
      trackEvent('repair_hero_whatsapp_click', { source: 'hero_secondary_link' });
    });
  }

  var allowedValues={ engin:['Trottinette électrique','Vélo électrique','Autre EDPM'], urgence:['Oui','Difficilement','Non, immobilisé'], contact:['WhatsApp','Email'] };

  function updateContactRequirements(){
    var phoneReq=document.getElementById('oraPhoneReq'), emailReq=document.getElementById('oraEmailReq'), emailHint=document.getElementById('oraEmailHint');
    var ch=answers.contact || 'WhatsApp';
    if (ch==='WhatsApp'){ if (phoneReq) phoneReq.textContent='*'; if (emailReq) emailReq.textContent=''; if (emailHint) emailHint.style.display='block'; }
    else { if (phoneReq) phoneReq.textContent=''; if (emailReq) emailReq.textContent='*'; if (emailHint) emailHint.style.display='none'; }
  }

  document.querySelectorAll('.ora-option[data-value]').forEach(function(btn){
    if (btn.classList.contains('ora-problem-main')) return;
    btn.addEventListener('click', function(){
      var step=this.closest('.ora-step'); if (!step || step.hasAttribute('data-ora-removed')) return;
      var key=step.getAttribute('data-key'), selectedValue=this.getAttribute('data-value');
      if (!key || !allowedValues[key] || allowedValues[key].indexOf(selectedValue)===-1) return;
      if (containsDangerousPatterns(selectedValue)) return;
      if (key === 'urgence') return;
      answers[key]=sanitizeInput(selectedValue);
      if (key==='contact') updateContactRequirements();
      var siblings=step.querySelectorAll('.ora-option[data-value]');
      for (var i=0;i<siblings.length;i++) {
        var on = siblings[i] === this;
        siblings[i].classList.toggle('ora-selected', on);
        siblings[i].setAttribute('aria-pressed', on ? 'true' : 'false');
      }

      if (key === 'engin' && ORA_COACH.engin[selectedValue]) setCoach(ORA_COACH.engin[selectedValue], 'ok');
      if (key === 'contact' && ORA_COACH.contact[selectedValue]) setCoach(ORA_COACH.contact[selectedValue], 'ok');

      updateLivePath();
      var persistSelection=key==='contact' || key==='engin';
      if (!persistSelection){ var self=this; setTimeout(function(){ self.classList.remove('ora-selected'); self.setAttribute('aria-pressed','false'); }, insightDelay()); }
      var idx = steps.indexOf(step);
      advanceStep(idx >= 0 ? idx : currentStep);
    });
  });

  if (btnPrev) btnPrev.addEventListener('click', goBack);

  function pad2(n){ return (n<10?'0':'')+n; }
  function isoDate_(d){
    return d.getFullYear() + '-' + pad2(d.getMonth() + 1) + '-' + pad2(d.getDate());
  }
  function parseIsoDateLocal_(s){
    var m = String(s || '').match(/^(\d{4})-(\d{2})-(\d{2})$/);
    if (!m) return null;
    return new Date(+m[1], +m[2] - 1, +m[3], 12, 0, 0);
  }
  var JOURS_FR_ = ['dimanche','lundi','mardi','mercredi','jeudi','vendredi','samedi'];
  var RDV_JOURS_ = ['lundi','mardi','mercredi','jeudi','vendredi','samedi'];
  var RDV_DELAI_JOURS_ = 2;
  var RDV_MIN_ISO_ = '';

  function estJourTravailleLocal_(d){
    if (!d) return false;
    return RDV_JOURS_.indexOf(JOURS_FR_[d.getDay()]) !== -1;
  }
  /** Première date autorisée : +N jours ouvrés hors aujourd’hui (ex. samedi → mardi). */
  function dateRdvMinimaleLocal_(depuis){
    var besoin = Math.max(1, RDV_DELAI_JOURS_ || 2);
    var cur = new Date(depuis || new Date());
    cur.setHours(12, 0, 0, 0);
    cur.setDate(cur.getDate() + 1);
    var n = 0, guard = 0;
    while (n < besoin && guard < 60) {
      if (estJourTravailleLocal_(cur)) {
        n++;
        if (n >= besoin) break;
      }
      cur.setDate(cur.getDate() + 1);
      guard++;
    }
    return cur;
  }
  function buildSlots(){ var slots=[]; for (var h=RDV_CFG.startHour;h<=RDV_CFG.endHour;h++){ for (var m=0;m<60;m+=RDV_CFG.stepMinutes){ if (h===RDV_CFG.endHour && m>0) break; slots.push(pad2(h)+':'+pad2(m)); } } return slots; }
  function setMinDate(){
    var dateEl = document.getElementById('oraDateInput');
    if (!dateEl) return;
    var minD = RDV_MIN_ISO_ ? parseIsoDateLocal_(RDV_MIN_ISO_) : dateRdvMinimaleLocal_();
    if (!minD) minD = dateRdvMinimaleLocal_();
    var iso = isoDate_(minD);
    dateEl.min = iso;
    if (!dateEl.value || dateEl.value < iso) dateEl.value = '';
    var hint = document.getElementById('oraRdvHint');
    if (!hint && dateEl.parentNode) {
      hint = document.createElement('p');
      hint.id = 'oraRdvHint';
      hint.className = 'ora-ex-hint';
      hint.style.marginTop = '0.35rem';
      dateEl.parentNode.appendChild(hint);
    }
    if (hint) {
      hint.textContent = 'Premier créneau possible : ' + pad2(minD.getDate()) + '/' +
        pad2(minD.getMonth() + 1) + '/' + minD.getFullYear() +
        ' (délai ~48 h, hors dimanche / jours de fermeture).';
      hint.hidden = false;
    }
  }
  function populateTimes(){ var timeSel=document.getElementById('oraTimeSelect'); if (!timeSel) return; var slots=buildSlots(); timeSel.innerHTML='<option value="">Choisir</option>'+slots.map(function(s){ return '<option value="'+s+'">'+s+'</option>'; }).join(''); }
  function appliquerConfigRdv_(cfg){
    if (!cfg || !cfg.rdv) return;
    if (cfg.rdv.startHour != null) RDV_CFG.startHour = Number(cfg.rdv.startHour) || RDV_CFG.startHour;
    if (cfg.rdv.endHour != null) RDV_CFG.endHour = Number(cfg.rdv.endHour) || RDV_CFG.endHour;
    if (cfg.rdv.stepMinutes != null) RDV_CFG.stepMinutes = Number(cfg.rdv.stepMinutes) || RDV_CFG.stepMinutes;
    if (cfg.rdv.delai_jours_ouvres != null) RDV_DELAI_JOURS_ = Math.max(1, Number(cfg.rdv.delai_jours_ouvres) || 2);
    if (cfg.rdv.jours_travailles && cfg.rdv.jours_travailles.length) {
      RDV_JOURS_ = cfg.rdv.jours_travailles.map(function(j){ return String(j || '').toLowerCase(); });
    }
    if (cfg.rdv.min_date) RDV_MIN_ISO_ = String(cfg.rdv.min_date);
    populateTimes();
    setMinDate();
    var hint = document.getElementById('oraRdvHint');
    if (hint && cfg.rdv.hint) { hint.textContent = cfg.rdv.hint; hint.hidden = false; }
  }
  setMinDate(); populateTimes();

  var rdvNext=document.getElementById('oraRdvNext'), rdvErr=document.getElementById('oraRdvError'), rdvDate=document.getElementById('oraDateInput'), rdvTime=document.getElementById('oraTimeSelect');
  if (rdvDate) {
    rdvDate.addEventListener('change', function(){
      var d = parseIsoDateLocal_(rdvDate.value);
      if (!d) return;
      if (!estJourTravailleLocal_(d) || (rdvDate.min && rdvDate.value < rdvDate.min)) {
        if (rdvErr) rdvErr.textContent = 'Date trop tôt ou atelier fermé ce jour-là.';
        markError(rdvDate);
        rdvDate.value = '';
        return;
      }
      if (rdvErr) rdvErr.textContent = '';
      resetField(rdvDate);
    });
  }
  if (rdvNext) rdvNext.addEventListener('click', function(){
    if (rdvErr) rdvErr.textContent='';
    resetField(rdvDate); resetField(rdvTime);
    var d=rdvDate.value, t=rdvTime.value;
    if (!d){ markError(rdvDate); if (rdvErr) rdvErr.textContent='Indiquez une date.'; return; }
    if (!t){ markError(rdvTime); if (rdvErr) rdvErr.textContent='Indiquez une heure.'; return; }
    if (containsDangerousPatterns(d+' '+t)){ if (rdvErr) rdvErr.textContent='Valeur invalide.'; return; }
    var dObj = parseIsoDateLocal_(d);
    if (!dObj || !estJourTravailleLocal_(dObj) || (rdvDate.min && d < rdvDate.min)) {
      markError(rdvDate);
      if (rdvErr) rdvErr.textContent = 'Date trop tôt ou atelier fermé (délai ~48 h, hors week-end).';
      return;
    }
    answers.rdv_date=sanitizeInput(d); answers.rdv_time=sanitizeInput(t);
    markSuccess(rdvDate); markSuccess(rdvTime);
    setCoach('Créneau noté : ' + d + ' à ' + t + ' — confirmation atelier avant intervention.', 'ok');
    advanceFromCurrent_();
  });

  var modelInput=document.getElementById('oraModelInput'), modelNext=document.getElementById('oraModelNext'), modelErr=document.getElementById('oraModelError');
  if (modelNext) modelNext.addEventListener('click', function(){
    if (modelErr) modelErr.textContent=''; if (modelInput) resetField(modelInput);
    var modelValue=modelInput?modelInput.value.trim():'';
    if (modelValue){
      if (containsDangerousPatterns(modelValue) || !validateInput(modelValue,'model')){ markError(modelInput); if (modelErr) modelErr.textContent='Modèle invalide (max. 100 caractères, caractères simples).'; return; }
      answers.modele=sanitizeInput(modelValue);
      setCoach('Modèle « ' + answers.modele + ' » enregistré — utile pour anticiper les pièces.', 'ok');
    } else {
      answers.modele='Non précisé';
      setCoach('Modèle non précisé : nous l’affinerons ensemble, sans bloquer la demande.', 'info');
    }
    advanceFromCurrent_();
  });

  var zipLive=document.getElementById('oraZip');
  if (zipLive) zipLive.addEventListener('input', function(){ var v=(zipLive.value||'').trim(); if (/^[0-9]{5}$/.test(v)) renderZoneCard(zoneDecisionFromZip(v)); else renderZoneCard(null); });

  var prenomInput=document.getElementById('oraPrenomInput');
  var nomInput=ensureNomField_();
  var phoneInput=document.getElementById('oraPhoneInput'), emailInput=document.getElementById('oraEmailInput'), addressLineInput=document.getElementById('oraAddressLine'), zipInput=document.getElementById('oraZip'), cityInput=document.getElementById('oraCity'), contactError=document.getElementById('oraContactError'), contactNext=document.getElementById('oraContactNext');

  if (contactNext) contactNext.addEventListener('click', function(){
    var honeypot=document.getElementById('oraWebsite'); if (honeypot && honeypot.value) return;
    if (contactError) contactError.textContent='';
    nomInput = document.getElementById('oraNomInput') || nomInput;
    resetField(prenomInput); resetField(nomInput); resetField(phoneInput); resetField(emailInput); resetField(addressLineInput); resetField(zipInput); resetField(cityInput);
    if (!answers.contact) answers.contact='WhatsApp';
    updateContactRequirements();
    var prenom=prenomInput ? prenomInput.value.trim() : '';
    var nom=nomInput ? nomInput.value.trim() : '';
    var ch=answers.contact, phone=phoneInput.value.trim(), email=emailInput.value.trim(), addr=addressLineInput.value.trim(), zip=zipInput.value.trim(), city=cityInput.value.trim(), valid=true;

    if (!prenom || containsDangerousPatterns(prenom) || !validateInput(prenom,'text') || prenom.length>60){ markError(prenomInput); valid=false; if (contactError) contactError.textContent='Prénom invalide.'; }
    else { markSuccess(prenomInput); answers.prenom=sanitizeInput(prenom); }

    if (!nom || containsDangerousPatterns(nom) || !validateInput(nom,'text') || nom.length>60){ markError(nomInput); valid=false; if (contactError && !contactError.textContent) contactError.textContent='Nom invalide.'; }
    else { markSuccess(nomInput); answers.nom=sanitizeInput(nom); }

    if (ch==='WhatsApp'){
      if (!phone || containsDangerousPatterns(phone) || !validateInput(phone,'phone')){ markError(phoneInput); valid=false; if (contactError && !contactError.textContent) contactError.textContent='Téléphone requis pour WhatsApp.'; }
      else { markSuccess(phoneInput); answers.phone=sanitizeInput(phone.replace(/\s+/g,'')); }
      if (email){
        if (containsDangerousPatterns(email) || !validateInput(email,'email')){ markError(emailInput); valid=false; if (contactError && !contactError.textContent) contactError.textContent='Email invalide.'; }
        else { markSuccess(emailInput); answers.email=sanitizeInput(email.toLowerCase()); }
      } else answers.email='';
    } else {
      if (!email || containsDangerousPatterns(email) || !validateInput(email,'email')){ markError(emailInput); valid=false; if (contactError && !contactError.textContent) contactError.textContent='Email requis.'; }
      else { markSuccess(emailInput); answers.email=sanitizeInput(email.toLowerCase()); }
      if (phone){
        if (containsDangerousPatterns(phone) || !validateInput(phone,'phone')){ markError(phoneInput); valid=false; if (contactError && !contactError.textContent) contactError.textContent='Téléphone invalide.'; }
        else { markSuccess(phoneInput); answers.phone=sanitizeInput(phone.replace(/\s+/g,'')); }
      } else answers.phone='';
    }

    var besoinAdresse = besoinAdressePrise_();
    if (besoinAdresse) {
      if (!addr || containsDangerousPatterns(addr) || !validateInput(addr,'text') || addr.length>120){ markError(addressLineInput); valid=false; if (contactError && !contactError.textContent) contactError.textContent='Adresse requise pour domicile / enlèvement.'; } else markSuccess(addressLineInput);
      if (!isValidZipFR(zip)){ markError(zipInput); valid=false; if (contactError && !contactError.textContent) contactError.textContent='Code postal : 5 chiffres.'; } else markSuccess(zipInput);
      if (!city || containsDangerousPatterns(city) || !validateInput(city,'text') || city.length>60){ markError(cityInput); valid=false; if (contactError && !contactError.textContent) contactError.textContent='Ville invalide.'; } else markSuccess(cityInput);
    } else {
      /* Dépôt atelier : adresse facultative */
      if (addr && (containsDangerousPatterns(addr) || !validateInput(addr,'text') || addr.length>120)){ markError(addressLineInput); valid=false; if (contactError && !contactError.textContent) contactError.textContent='Adresse invalide.'; }
      else if (addressLineInput) markSuccess(addressLineInput);
      if (zip && !isValidZipFR(zip)){ markError(zipInput); valid=false; if (contactError && !contactError.textContent) contactError.textContent='Code postal : 5 chiffres.'; }
      else if (zipInput) markSuccess(zipInput);
      if (city && (containsDangerousPatterns(city) || !validateInput(city,'text') || city.length>60)){ markError(cityInput); valid=false; if (contactError && !contactError.textContent) contactError.textContent='Ville invalide.'; }
      else if (cityInput) markSuccess(cityInput);
    }
    if (!valid && contactError && !contactError.textContent) contactError.textContent='Merci de compléter les champs.';
    if (!valid) return;

    if (!besoinAdresse && !zip) {
      answers.zip = '';
      answers.city = sanitizeInput(city || '');
      answers.address_line = sanitizeInput(addr || '');
      answers.address_full = answers.address_line;
      answers.zone_level = 'OK';
      answers.travel_fee = 0;
      renderZoneCard({ level:'OK', travel_fee: 0, msg: 'Dépôt atelier — pas de frais de déplacement.' });
      advanceFromCurrent_();
      return;
    }

    var dec=zoneDecisionFromZip(zip);
    answers.zip_dep=dec.dep || zip.slice(0,2);
    answers.zone_level=dec.level;
    var veutDeplacement = besoinAdresse;
    if (dec.level==='INVALID' || (dec.level==='BLOCK' && veutDeplacement)){
      renderZoneCard(dec); if (contactError) contactError.textContent=''; return;
    }
    if (dec.level==='BLOCK' && !veutDeplacement){
      answers.zone_level = 'BLOCK';
    }

    answers.address_line=sanitizeInput(addr);
    answers.zip=sanitizeInput(zip);
    answers.city=sanitizeInput(city);
    answers.address_full=answers.address_line+', '+answers.zip+' '+answers.city;
    var apiZone = window.OraRepairApi;
    function continuerZone(info){
      var aff = dec.level==='MANUAL' ? dec : { level:'OK' };
      var deplacement = besoinAdressePrise_();
      if (!deplacement) {
        aff.travel_fee = 0;
        answers.travel_fee = 0;
        if (answers.zone_level === 'BLOCK') {
          renderZoneCard({ level:'MANUAL', msg:'Le déplacement à domicile n’est pas disponible dans ce secteur. Le dépôt atelier reste possible.' });
        } else {
          renderZoneCard(aff);
        }
        advanceFromCurrent_();
        return;
      }
      if (info && info.level) {
        answers.zone_level = info.level;
        if (info.level==='BLOCK' || info.level==='INVALID') {
          renderZoneCard({ level: info.level, msg: info.message || 'Hors zone.' });
          return;
        }
        aff.travel_fee = info.travel_fee;
        aff.message = info.message || '';
        answers.travel_fee = info.travel_fee;
      }
      renderZoneCard(aff);
      advanceFromCurrent_();
    }
    if (apiZone && apiZone.estimateZone) {
      apiZone.estimateZone(answers.zip, answers.address_line, answers.city).then(continuerZone).catch(function(){ continuerZone(null); });
    } else continuerZone(null);
  });

  function zoneLabel(){ if (answers.zone_level==='MANUAL') return 'Zone à confirmer'; if (answers.zone_level==='OK') return 'Zone couverte'; return answers.zone_level || '-'; }

  function renderSummary(){
    var list=document.getElementById('oraSummaryList'); if (!list) return;
    var rdvTxt=(answers.rdv_date && answers.rdv_time)?(answers.rdv_date+' à '+answers.rdv_time):'-';
    var orientation = answers.prise_en_charge_label || recommendPriseEnCharge(answers.probleme_main, answers.urgence) || 'À confirmer avec l’atelier';
    var items=[
      { l:'Véhicule', v:answers.engin || '-' },
      { l:'Modèle', v:answers.modele || 'Non précisé' },
      { l:'Panne', v:answers.probleme || '-' },
    ];
    if (answers.prestation_demandee) {
      items.splice(2, 0, { l:'Prestation souhaitée', v:answers.prestation_demandee });
    }
    items = items.concat([
      { l:'Orientation', v:orientation },
      { l:'Créneau demandé', v:rdvTxt },
      { l:'Zone', v:zoneLabel() },
      { l:'Déplacement', v: answers.travel_fee != null && answers.travel_fee !== '' ? (answers.travel_fee + ' €') : 'À confirmer' },
      { l:'Adresse', v:answers.address_full || '-' },
      { l:'Canal', v:answers.contact || 'WhatsApp' },
      { l:'Prénom', v:answers.prenom || '-' },
      { l:'Nom', v:answers.nom || '-' },
      { l:'Téléphone', v:answers.phone || '-' },
      { l:'Email', v:answers.email || '-' }
    ]);
    if (answers.express && (answers.express_prestation || (answers.express_lignes && answers.express_lignes.length))) {
      var exLab = answers.express_prestation || '';
      if (!exLab && answers.express_lignes) {
        exLab = answers.express_lignes.map(function (x) { return x.prestation; }).filter(Boolean).join(' + ');
      }
      items.splice(2, 0,
        { l:'Prestation Express', v:exLab || '-' },
        { l:'Estimation Express', v: answers.express_total != null ? (answers.express_total + ' € TTC') : 'À confirmer' }
      );
    }
    var keyLabels={ 'Panne':1, 'Orientation':1, 'Créneau demandé':1, 'Zone':1 };
    list.innerHTML=items.map(function(it){ var keyClass=keyLabels[it.l]?' class="ora-summary-key"':''; return '<li'+keyClass+'><strong>'+escapeHtml(it.l)+' :</strong> '+escapeHtml(String(it.v))+'</li>'; }).join('');
    ensureAcompteBox_();
    setCoach('Récapitulatif prêt. Aucun engagement sans votre accord — l’atelier confirme ensuite.', 'ok');
  }

  /**
   * Encadré acompte — après le récap, juste avant le bouton d’envoi.
   * Injecté si absent du Liquid (rétrocompatible avec anciennes sections).
   */
  function ensureAcompteBox_() {
    if (document.getElementById('oraAcompteBox')) return;
    var btn = document.getElementById('oraSendBtn');
    if (!btn || !btn.parentNode) return;
    var box = document.createElement('div');
    box.id = 'oraAcompteBox';
    box.className = 'ora-acompte-box';
    box.setAttribute('role', 'group');
    box.setAttribute('aria-labelledby', 'oraAcompteTitle');
    box.innerHTML =
      '<div class="ora-acompte-inner">' +
        '<h3 id="oraAcompteTitle" class="ora-acompte-title">Acompte de prise en charge</h3>' +
        '<p class="ora-acompte-text">Selon la nature et le montant de l’intervention, un acompte pouvant représenter jusqu’à 50&nbsp;% du montant estimé pourra être demandé pour valider la prise en charge.</p>' +
        '<p class="ora-acompte-text">La prise en charge n’est confirmée qu’après encaissement de cet acompte.</p>' +
        '<p class="ora-acompte-text">En cas de rendez-vous non honoré sans annulation, l’acompte versé pourra être conservé.</p>' +
        '<label class="ora-acompte-label" for="oraAcompteAccept">' +
          '<input type="checkbox" id="oraAcompteAccept" name="ora_acompte_accept" value="1" />' +
          '<span>Je reconnais avoir pris connaissance et accepter les modalités relatives à l’acompte et à la validation de ma prise en charge.</span>' +
        '</label>' +
        '<p id="oraAcompteError" class="ora-acompte-error" role="alert" hidden></p>' +
      '</div>';
    btn.parentNode.insertBefore(box, btn);
    if (!document.getElementById('oraAcompteStyles')) {
      var st = document.createElement('style');
      st.id = 'oraAcompteStyles';
      st.textContent =
        '.ora-acompte-box{margin:1.25rem 0 1rem;border-left:3px solid #E86A33;background:rgba(232,106,51,.08);border-radius:0 10px 10px 0;}' +
        '.ora-acompte-inner{padding:1rem 1rem 1.1rem 1.1rem;}' +
        '.ora-acompte-title{margin:0 0 .65rem;font-size:1.05rem;font-weight:650;color:#1a1a1a;}' +
        '.ora-acompte-text{margin:0 0 .55rem;font-size:.92rem;line-height:1.45;color:#333;}' +
        '.ora-acompte-label{display:flex;align-items:flex-start;gap:.7rem;margin-top:.85rem;cursor:pointer;font-size:.95rem;line-height:1.4;color:#1a1a1a;-webkit-tap-highlight-color:transparent;}' +
        '.ora-acompte-label input{margin-top:.2rem;width:1.15rem;height:1.15rem;flex:0 0 auto;accent-color:#E86A33;}' +
        '.ora-acompte-error{margin:.65rem 0 0;font-size:.9rem;color:#b42318;}' +
        '.ora-acompte-box.ora-acompte-invalid{outline:2px solid #b42318;outline-offset:2px;}';
      document.head.appendChild(st);
    }
  }

  function acompteAccepte_() {
    var cb = document.getElementById('oraAcompteAccept');
    return !!(cb && cb.checked);
  }

  function bloquerAcompte_() {
    ensureAcompteBox_();
    var err = document.getElementById('oraAcompteError');
    var box = document.getElementById('oraAcompteBox');
    var msg = 'Veuillez confirmer avoir pris connaissance des modalités relatives à l’acompte.';
    if (err) {
      err.textContent = msg;
      err.removeAttribute('hidden');
    }
    if (box) {
      box.classList.add('ora-acompte-invalid');
      try { box.scrollIntoView({ behavior: preferReducedMotion ? 'auto' : 'smooth', block: 'center' }); } catch (eScroll) {}
    }
    var subErr = document.getElementById('oraSubmitError');
    if (subErr) subErr.textContent = msg;
    var cb = document.getElementById('oraAcompteAccept');
    if (cb) {
      try { cb.focus(); } catch (eF) {}
      cb.addEventListener('change', function once() {
        if (cb.checked) {
          if (err) { err.textContent = ''; err.setAttribute('hidden', 'hidden'); }
          if (box) box.classList.remove('ora-acompte-invalid');
          if (subErr && subErr.textContent === msg) subErr.textContent = '';
        }
      });
    }
  }

  var PHOTO_LINE='Photos (1 à 3) sur WhatsApp : utiles pour affiner le diagnostic.';

  function buildMessage(){
    var zt=zoneLabel(), rdv=(answers.rdv_date && answers.rdv_time)?(answers.rdv_date+' à '+answers.rdv_time):'-', lines=[];
    lines.push('——— DEMANDE — ORATELIER ———','');
    lines.push('Prénom : ' + sanitizeForPayload(answers.prenom || '-'));
    lines.push('Nom : ' + sanitizeForPayload(answers.nom || '-'));
    lines.push('Téléphone : ' + sanitizeForPayload(answers.phone || '-'));
    lines.push('Email : ' + sanitizeForPayload(answers.email || '-'));
    lines.push('Canal : ' + sanitizeForPayload(answers.contact || 'WhatsApp'),'');
    lines.push('Adresse : ' + sanitizeForPayload(answers.address_full || '-'));
    lines.push('Zone : ' + sanitizeForPayload(zt),'');
    lines.push('Créneau demandé (à confirmer) : ' + sanitizeForPayload(rdv),'');
    lines.push('Véhicule : ' + sanitizeForPayload(answers.engin || '-'));
    lines.push('Panne : ' + sanitizeForPayload(answers.probleme_main || '-'));
    lines.push('Précisions atelier :');
    lines.push(buildProblemeDetailBlockWA(),'');
    lines.push('Modèle : ' + sanitizeForPayload(answers.modele || 'Non précisé'));
    if (answers.probleme_notes && answers.probleme_main !== 'Autre problème') lines.push('Précision : ' + sanitizeForPayload(answers.probleme_notes));
    lines.push('', PHOTO_LINE, '', 'Horodatage : ' + new Date().toLocaleString('fr-FR'));
    return lines.join('\n');
  }

  function buildEmailJSPayload(){
    var rdvTxt=(answers.rdv_date && answers.rdv_time)?(answers.rdv_date+' à '+answers.rdv_time):'-';
    var desc=buildProblemeDetailBlockWA();
    return {
      nom:sanitizeForPayload(answers.nom || ''),
      prenom:sanitizeForPayload(answers.prenom || ''),
      telephone:sanitizeForPayload(answers.phone || ''),
      email:sanitizeForPayload(answers.email || ''),
      adresse:sanitizeForPayload(answers.address_full || ''),
      modele:sanitizeForPayload(answers.modele || 'Non précisé'),
      panne:sanitizeForPayload(answers.probleme || ''),
      intervention:sanitizeForPayload(answers.engin || ''),
      pret:'',
      description:sanitizeForPayload(desc),
      date:sanitizeForPayload(rdvTxt)
    };
  }

  var sendingTimer_ = null;
  var sendingMsgIdx_ = 0;
  var sendingStartedAt_ = 0;
  var SENDING_MSGS_EARLY_ = [
    'On crée votre fiche…',
    'L’atelier ouvre un nouveau dossier…',
    'On range vos infos soigneusement…',
    'Petite vérification express…'
  ];
  var SENDING_MSGS_MID_ = [
    'Patience, ça mijote côté atelier…',
    'Encore un instant…',
    'On verrouille votre demande…'
  ];
  var SENDING_MSGS_LATE_ = [
    'C’est presque fini…',
    'Dernière ligne droite…',
    'Et hop — on finalise…'
  ];

  function ensureSendingUi_() {
    var load = document.getElementById('oraLoading');
    if (!load) return null;
    var status = document.getElementById('oraSendingStatus');
    if (!status) {
      status = document.createElement('p');
      status.id = 'oraSendingStatus';
      status.className = 'ora-sending-status';
      status.setAttribute('aria-live', 'polite');
      if (load.nextSibling) load.parentNode.insertBefore(status, load.nextSibling);
      else load.parentNode.appendChild(status);
    }
    return status;
  }

  function pickSendingMsg_() {
    var elapsed = Date.now() - (sendingStartedAt_ || Date.now());
    var pool = SENDING_MSGS_EARLY_;
    if (elapsed >= 9000) pool = SENDING_MSGS_LATE_;
    else if (elapsed >= 4500) pool = SENDING_MSGS_MID_;
    var msg = pool[sendingMsgIdx_ % pool.length];
    sendingMsgIdx_++;
    return msg;
  }

  function stopSendingMessages_() {
    if (sendingTimer_) {
      clearInterval(sendingTimer_);
      sendingTimer_ = null;
    }
    var status = document.getElementById('oraSendingStatus');
    if (status) {
      status.textContent = '';
      status.classList.remove('ora-on');
    }
  }

  function startSendingMessages_() {
    stopSendingMessages_();
    var status = ensureSendingUi_();
    if (!status) return;
    sendingStartedAt_ = Date.now();
    sendingMsgIdx_ = 0;
    status.textContent = pickSendingMsg_();
    status.classList.add('ora-on');
    sendingTimer_ = setInterval(function () {
      var el = document.getElementById('oraSendingStatus');
      if (!el) return;
      el.classList.remove('ora-tick');
      void el.offsetWidth;
      el.textContent = pickSendingMsg_();
      el.classList.add('ora-tick');
    }, 2200);
  }

  function setSending(on) {
    var btn = document.getElementById('oraSendBtn');
    var load = document.getElementById('oraLoading');
    if (btn) {
      btn.disabled = !!on;
      if (on) {
        if (!btn.getAttribute('data-ora-label')) btn.setAttribute('data-ora-label', btn.textContent || '');
        btn.textContent = 'Envoi en cours…';
      } else if (btn.getAttribute('data-ora-label')) {
        btn.textContent = btn.getAttribute('data-ora-label');
        btn.removeAttribute('data-ora-label');
      }
    }
    if (load) load.classList.toggle('ora-on', !!on);
    if (on) startSendingMessages_();
    else stopSendingMessages_();
  }

  function showFinalMessage(emailOk, waUrlForModal, emailAttempted, apiResult){
    var modal=document.getElementById('oraModal');
    var modalThanks=document.getElementById('oraModalThanks');
    var modalTitle=document.getElementById('oraModalTitle');
    var closeBtn=document.getElementById('oraModalClose');
    var modalWaCta=document.getElementById('oraModalWaCta');
    var modalWaLink=document.getElementById('oraModalWaLink');
    var modalHello=document.getElementById('oraModalHello');
    var modalRef=document.getElementById('oraModalRef');
    var modalRefValue=document.getElementById('oraModalRefValue');
    var modalMeta=document.getElementById('oraModalMeta');
    var modalTrack=document.getElementById('oraModalTrackLink');
    if (!modal || !closeBtn) return;

    var ref = apiResult && apiResult.reference ? String(apiResult.reference) : '';
    var tracking = apiResult && apiResult.tracking_url ? String(apiResult.tracking_url) : '';
    var prenom = answers.prenom || '';
    var showWa = typeof waUrlForModal === 'string' && waUrlForModal.indexOf('https://wa.me/') === 0;

    if (modalTitle) modalTitle.textContent = 'Votre demande est bien enregistrée.';

    if (modalHello) {
      modalHello.innerHTML = prenom
        ? 'Merci <strong>' + escapeHtml(prenom) + '</strong>. Votre demande est bien enregistrée.'
        : 'Votre demande est bien enregistrée.';
    }

    if (modalRef && modalRefValue) {
      if (ref) {
        modalRefValue.textContent = ref;
        modalRef.removeAttribute('hidden');
      } else {
        modalRef.setAttribute('hidden', 'hidden');
        modalRefValue.textContent = '';
      }
    }

    if (modalMeta) {
      var rows = [];
      if (answers.modele && answers.modele !== 'Non précisé') rows.push(['Véhicule', answers.modele]);
      else if (answers.engin) rows.push(['Véhicule', answers.engin]);
      if (answers.probleme_main) rows.push(['Panne', answers.probleme_main]);
      if (answers.prise_en_charge_label) rows.push(['Orientation', answers.prise_en_charge_label]);
      if (answers.rdv_date && answers.rdv_time) {
        rows.push(['Créneau souhaité', answers.rdv_date + ' — ' + answers.rdv_time]);
      }
      modalMeta.innerHTML = rows.map(function (r) {
        return '<li><span>' + escapeHtml(r[0]) + '</span><strong>' + escapeHtml(r[1]) + '</strong></li>';
      }).join('');
    }

    if (modalThanks) {
      modalThanks.textContent = 'Pour faciliter la prise en charge, envoyez maintenant votre récapitulatif sur WhatsApp.';
    }

    if (modalTrack) {
      if (tracking) {
        modalTrack.href = tracking;
        modalTrack.removeAttribute('hidden');
      } else {
        modalTrack.setAttribute('hidden', 'hidden');
      }
    }

    if (modalWaLink) {
      if (showWa) {
        modalWaLink.href = waUrlForModal;
        modalWaLink.textContent = 'Envoyer le récapitulatif sur WhatsApp';
        modalWaLink.removeAttribute('hidden');
        modalWaLink.removeAttribute('data-ora-open');
        modalWaLink.onclick = function (ev) {
          if (modalWaLink.getAttribute('data-ora-open') === '1') {
            ev.preventDefault();
            return;
          }
          modalWaLink.setAttribute('data-ora-open', '1');
          var apiCta = window.OraRepairApi;
          if (apiCta && apiCta.postWhatsappCta) apiCta.postWhatsappCta(ref, '');
        };
      } else {
        modalWaLink.setAttribute('hidden', 'hidden');
      }
    }
    if (modalWaCta) {
      if (showWa) modalWaCta.removeAttribute('hidden');
      else modalWaCta.setAttribute('hidden', 'hidden');
    }

    var modalPhotoHint = document.getElementById('oraModalPhotoHint');
    if (modalPhotoHint) modalPhotoHint.removeAttribute('hidden');

    modal.classList.add('ora-open');
    modal.setAttribute('aria-hidden', 'false');
    setTimeout(function () { closeBtn.focus(); }, 250);

    if (modal._oraCloseHandler) {
      closeBtn.removeEventListener('click', modal._oraCloseHandler);
      window.removeEventListener('click', modal._oraBackdropHandler);
      window.removeEventListener('keydown', modal._oraEscHandler);
    }
    function closeHandler() {
      modal.classList.remove('ora-open');
      modal.setAttribute('aria-hidden', 'true');
      closeBtn.removeEventListener('click', closeHandler);
      window.removeEventListener('click', outsideClickHandler);
      window.removeEventListener('keydown', escapeHandler);
      modal._oraCloseHandler = null;
      modal._oraBackdropHandler = null;
      modal._oraEscHandler = null;
    }
    function outsideClickHandler(e) { if (e.target === modal) closeHandler(); }
    function escapeHandler(e) { if (e.key === 'Escape') closeHandler(); }
    modal._oraCloseHandler = closeHandler;
    modal._oraBackdropHandler = outsideClickHandler;
    modal._oraEscHandler = escapeHandler;
    closeBtn.addEventListener('click', closeHandler);
    window.addEventListener('click', outsideClickHandler);
    window.addEventListener('keydown', escapeHandler);
  }

  function buildSitePayload(submissionId) {
    var honeypot = document.getElementById('oraWebsite');
    var accepte = acompteAccepte_();
    var marqueParts = String(answers.modele || '').trim().split(/\s+/);
    var marqueSeule = answers.express_marque || marqueParts[0] || '';
    var vehiculePayload = {
      type: answers.engin || '',
      marque: marqueSeule,
      modele: answers.modele || '',
      panne: answers.probleme_main || '',
      details: answers.probleme_precision || {},
      prestation: answers.express_prestation || '',
      position: answers.express_position || '',
      express_compat_id: answers.express_compat_id || ''
    };
    return {
      action: 'create_intervention',
      submission_id: submissionId,
      source: 'site_oratelier',
      origine: answers.express ? 'express_shopify' : 'formulaire_shopify',
      flow_type: answers.express ? 'express' : 'standard',
      formulaire_version: 'v2',
      acompte_conditions_acceptees: accepte,
      acompte_conditions_version: 'v1',
      acompte_conditions_acceptees_le: accepte ? new Date().toISOString() : '',
      express_compat_id: answers.express_compat_id || '',
      express_prestation: answers.express_prestation || '',
      express_position: answers.express_position || '',
      express_piece: answers.express_piece || '',
      express_prix_piece: answers.express_prix_piece != null ? String(answers.express_prix_piece) : '',
      express_prix_mo: answers.express_prix_mo != null ? String(answers.express_prix_mo) : '',
      express_total: answers.express_total != null ? String(answers.express_total) : '',
      express_lignes: (answers.express_lignes || []).map(function (x) {
        return {
          compat_id: x.compat_id || '',
          position: x.position || '',
          prestation: x.prestation || ''
        };
      }).filter(function (x) { return !!x.compat_id; }),
      prenom: answers.prenom || '',
      nom: answers.nom || '',
      telephone: answers.phone || '',
      email: answers.email || '',
      canal_prefere: answers.contact || 'WhatsApp',
      type_vehicule: answers.engin || '',
      marque_modele: answers.modele || '',
      categorie_panne: answers.probleme_main || '',
      details_panne: answers.probleme_precision || {},
      note_client: answers.probleme_notes || '',
      code_erreur: answers.code_erreur || (answers.probleme_precision && answers.probleme_precision.code_erreur) || '',
      vehicule_utilisable: answers.urgence || '',
      prise_en_charge_key: answers.prise_en_charge_key || 'recommandation',
      prise_en_charge_label: answers.prise_en_charge_label || '',
      adresse: answers.address_line || '',
      code_postal: answers.zip || '',
      ville: answers.city || '',
      date_souhaitee: answers.rdv_date || '',
      heure_souhaitee: answers.rdv_time || '',
      mobilite_temporaire: !!answers.mobilite_temporaire,
      vehicules: [vehiculePayload],
      website: honeypot ? honeypot.value : ''
    };
  }

  var sendBtnElement=document.getElementById('oraSendBtn');
  if (sendBtnElement) sendBtnElement.addEventListener('click', function(e){
    e.preventDefault();
    if (submitLock) return;
    trackEvent('form_submit', { contact_channel: answers.contact || 'WhatsApp' });
    var subErr=document.getElementById('oraSubmitError'), fb=document.getElementById('oraFeedback'), successCheck=document.getElementById('oraSuccessCheck');
    if (subErr) subErr.textContent='';
    var waFb=document.getElementById('oraWaFallback');
    if (waFb){ waFb.classList.remove('ora-visible'); waFb.setAttribute('hidden','hidden'); }
    if (fb){ fb.textContent=''; fb.classList.remove('ora-visible'); }
    if (successCheck) successCheck.classList.remove('ora-visible');
    var waWrapReset=document.getElementById('oraSuccessWaWrap');
    if (waWrapReset){ waWrapReset.setAttribute('hidden','hidden'); waWrapReset.classList.remove('ora-visible'); }

    if (!checkRateLimit()){ if (subErr) subErr.textContent='Trop de tentatives. Patientez quelques secondes.'; return; }
    var honeypot=document.getElementById('oraWebsite'); if (honeypot && honeypot.value) return;
    if (!answers.contact) answers.contact='WhatsApp';
    ensureUrgenceDefault_();

    if (!answers.prenom || !answers.nom || !answers.rdv_date || !answers.rdv_time || !answers.engin || !answers.probleme || !answers.urgence ||
      !answers.prise_en_charge_key ||
      (besoinAdressePrise_() && (!answers.address_full || !answers.zip || !answers.city)) ||
      (answers.zone_level==='INVALID') ||
      ((answers.zone_level==='BLOCK') && besoinAdressePrise_()) ||
      (answers.contact==='WhatsApp' && !answers.phone) ||
      (answers.contact==='Email' && !answers.email)) {
      if (subErr) subErr.textContent='Informations incomplètes — repassez les étapes précédentes.';
      return;
    }

    ensureAcompteBox_();
    if (!acompteAccepte_()) {
      bloquerAcompte_();
      return;
    }

    var allData=[answers.prenom,answers.nom,answers.phone,answers.email,answers.modele,answers.engin,answers.probleme,answers.urgence,answers.rdv_date,answers.rdv_time,answers.address_full,answers.zip,answers.city].join(' ');
    if (containsDangerousPatterns(allData)){ if (subErr) subErr.textContent='Données refusées (caractères non autorisés).'; return; }

    submitLock = true;
    setSending(true);
    if (fb){ fb.textContent=''; fb.classList.remove('ora-visible'); }

    var api = window.OraRepairApi;
    var submissionId = api && api.getOrCreateSubmissionId ? api.getOrCreateSubmissionId() : ('local-' + Date.now());
    var useApi = api && api.apiEnabled && api.apiEnabled();

    function waUrlFor(ref) {
      if (api && api.buildWaUrl) return api.buildWaUrl(ref || '', answers, WA_NUMBER);
      var msg = buildMessage();
      if (ref) msg = 'Référence : ' + ref + '\n\n' + msg;
      return 'https://wa.me/' + WA_NUMBER + '?text=' + encodeURIComponent(msg);
    }

    function openWhatsApp(url) {
      try {
        var waAnchor=document.createElement('a');
        waAnchor.href=url; waAnchor.target='_blank'; waAnchor.rel='noopener noreferrer'; waAnchor.style.display='none';
        document.body.appendChild(waAnchor); waAnchor.click(); document.body.removeChild(waAnchor);
      } catch (eOpen) {}
      trackEvent('whatsapp_open', { contact_channel: answers.contact || 'WhatsApp' });
      var waWrap=document.getElementById('oraSuccessWaWrap'), waLinkEl=document.getElementById('oraSuccessWaLink');
      if (waWrap && waLinkEl){ waLinkEl.href=url; waWrap.removeAttribute('hidden'); waWrap.classList.add('ora-visible'); }
    }

    function unlock(){ submitLock=false; setSending(false); }

    function afterInterventionOk(apiResult) {
      lastApiResult = apiResult || {};
      submitAttempts++; lastSubmitTime=Date.now();
      if (api && api.clearDraft) api.clearDraft();
      if (api && api.clearSubmissionId) api.clearSubmissionId();
      trackEvent('form_success', { has_reference: !!(apiResult && apiResult.reference) });
      if (fb){ fb.textContent=''; fb.classList.remove('ora-visible'); }
      var sct=document.getElementById('oraSuccessCheckText');
      var ref = apiResult && apiResult.reference ? apiResult.reference : '';
      if (sct) {
        sct.textContent = ref
          ? ('Demande enregistrée — référence ' + ref)
          : 'Demande enregistrée — l’atelier vous recontacte sous peu.';
      }
      if (successCheck) successCheck.classList.add('ora-visible');
      var waUrl = waUrlFor(ref);
      showFinalMessage(true, waUrl, (answers.contact || 'WhatsApp') === 'Email', apiResult);
      unlock();

      /* Notifications non bloquantes */
      if ((answers.contact || 'WhatsApp') === 'Email' && window.emailjs && typeof emailjs.send === 'function') {
        try {
          var mailPayload = buildEmailJSPayload();
          if (ref) mailPayload.reference = ref;
          emailjs.send('service_8hz35ho', 'template_oj4prbi', mailPayload).catch(function () {});
        } catch (eMail) {}
      }
    }

    function afterFailure(errMsg, errCode) {
      unlock();
      trackEvent('form_error', { error_code: errCode || 'unknown' });
      if (fb){ fb.textContent=''; fb.classList.remove('ora-visible'); }
      if (errCode === 'ACOMPTE_CONDITIONS_REQUIRED') {
        bloquerAcompte_();
        return;
      }
      var msgFail = errMsg || 'Votre demande n’a pas encore pu être enregistrée. Vos informations sont conservées sur cet appareil.';
      if (subErr) subErr.textContent = msgFail;
      if (api && api.saveDraft) {
        try { api.saveDraft({ answers: answers, step: currentStep }); } catch (eDraft) {}
      }
      var waUrl = waUrlFor('');
      var waFbEl=document.getElementById('oraWaFallback'), waLink=document.getElementById('oraWaFallbackLink');
      if (waFbEl && waLink){
        waLink.href = waUrl;
        waFbEl.removeAttribute('hidden'); waFbEl.classList.add('ora-visible');
      }
    }

    if (useApi) {
      api.postCreate(buildSitePayload(submissionId))
        .then(function (result) {
          if (result && result.success && result.reference) {
            afterInterventionOk(result);
            return;
          }
          if (result && result.success && !result.reference) {
            afterFailure('Demande non confirmée. Réessayez.', result.error_code || 'NO_REFERENCE');
            return;
          }
          afterFailure(
            (result && result.message) || 'Votre demande n’a pas encore pu être enregistrée.',
            result && result.error_code
          );
        })
        .catch(function () {
          afterFailure('Votre demande n’a pas encore pu être enregistrée. Vérifiez votre connexion puis réessayez.', 'NETWORK');
        });
      return;
    }

    /* Fallback si l'API n'est pas disponible : pas de second dossier, WhatsApp seulement au clic. */
    if ((answers.contact || 'WhatsApp') === 'Email' && window.emailjs && typeof emailjs.send === 'function') {
      emailjs.send('service_8hz35ho', 'template_oj4prbi', buildEmailJSPayload())
        .then(function () { afterInterventionOk({ reference: '', tracking_url: '' }); })
        .catch(function () { afterFailure('L’envoi par email a échoué.', 'EMAILJS'); });
    } else {
      afterInterventionOk({ reference: '', tracking_url: '' });
    }
  });

  if (window.emailjs && typeof emailjs.init==='function') emailjs.init('xf16Cv2SnGp75CGpC');

  /* Init silencieux : pas de coach tant que le funnel n’est pas démarré */
  if (oraCoach) oraCoach.hidden = true;

  function stepIndexByKeyName_(name) {
    for (var i = 0; i < steps.length; i++) {
      if (stepKey_(steps[i]) === name) return i;
    }
    return -1;
  }

  function mapPrestationToProbleme_(prestation) {
    var p = String(prestation || '').toLowerCase();
    if (p.indexOf('frein') !== -1 || p.indexOf('plaquette') !== -1 || p.indexOf('disque') !== -1) return 'Freinage';
    return 'Pneu / crevaison';
  }

  function initExpress(){
    var api = window.OraRepairApi;
    if (!api) return;

    function hideCommencer_() {
      var welcome = document.getElementById('oraWelcome');
      if (welcome) welcome.classList.add('ora-has-path-choice');
      var welcomeStartBtn = document.getElementById('oraWelcomeStart');
      if (welcomeStartBtn) {
        welcomeStartBtn.hidden = true;
        welcomeStartBtn.setAttribute('aria-hidden', 'true');
        welcomeStartBtn.style.setProperty('display', 'none', 'important');
      }
      /* Au cas où le Liquid a un autre bouton « Commencer » dans le hero */
      if (welcome) {
        welcome.querySelectorAll('button, a').forEach(function (el) {
          var t = String(el.textContent || '').replace(/\s+/g, ' ').trim().toLowerCase();
          if (t === 'commencer' || el.id === 'oraWelcomeStart') {
            el.hidden = true;
            el.setAttribute('aria-hidden', 'true');
            el.style.setProperty('display', 'none', 'important');
          }
        });
      }
    }

    function expressAllowed_(cfg) {
      /* Afficher le choix Express (parcours v2). Pour le masquer plus tard :
         PARAMETRES feature_express = NON + republier ce JS en restaurant le gate serveur. */
      return true;
    }

    /* Masquer Commencer tout de suite (avant l’appel config async) */
    hideCommencer_();

    function bootExpress_(cfg) {
      if (!expressAllowed_(cfg)) {
        var w = document.getElementById('oraWelcome');
        if (w) w.classList.add('ora-show-classic-start');
        var btn = document.getElementById('oraWelcomeStart');
        if (btn) {
          btn.hidden = false;
          btn.removeAttribute('aria-hidden');
          btn.style.removeProperty('display');
        }
        return;
      }
      var welcome = document.getElementById('oraWelcome');
      if (!welcome || document.getElementById('oraExpressOpen')) return;

      hideCommencer_();

      var choice = document.createElement('div');
      choice.id = 'oraPathChoice';
      choice.className = 'ora-path-choice';
      choice.innerHTML =
        '<p class="ora-path-choice-label">Que souhaitez-vous ?</p>' +
        '<button type="button" id="oraExpressOpen" class="ora-path-btn ora-path-btn-express">Réparation Express — pneu, chambre, freins</button>' +
        '<button type="button" id="oraStandardOpen" class="ora-path-btn ora-path-btn-standard">Panne / diagnostic</button>';
      welcome.appendChild(choice);

      var box = document.createElement('div');
      box.id = 'oraExpressBox';
      box.className = 'ora-express-box';
      box.hidden = true;
      box.innerHTML =
        '<p id="oraExProgress" class="ora-ex-progress"></p>' +
        '<div id="oraExStepPrestation" class="ora-ex-step">' +
          '<p class="ora-ex-lead">Quelles pièces ? (plusieurs possibles)</p>' +
          '<p class="ora-ex-hint">Cochez une ou plusieurs interventions. Pack MO : la plus chère à 100&nbsp;%, les autres à −50&nbsp;%.</p>' +
          '<div id="oraExPrestBtns" class="ora-ex-stack"></div>' +
          '<p id="oraExPrestEmpty" class="ora-ex-lead" hidden>Aucune pièce Express validée pour le moment — parcours classique possible.</p>' +
          '<div class="ora-ex-actions">' +
            '<button type="button" id="oraExPrestNext" class="ora-ex-btn" disabled>Continuer</button>' +
          '</div>' +
        '</div>' +
        '<div id="oraExStepVehicule" class="ora-ex-step" hidden>' +
          '<p class="ora-ex-lead">Choisissez dans la liste Express (pièces déjà validées).</p>' +
          '<label class="ora-ex-field"><span class="ora-ex-label">Marque</span>' +
            '<select id="oraExMarque" class="ora-input ora-ex-select">' +
              '<option value="">— Choisir —</option>' +
            '</select>' +
          '</label>' +
          '<label class="ora-ex-field" style="margin-top:.75rem"><span class="ora-ex-label">Modèle</span>' +
            '<select id="oraExModele" class="ora-input ora-ex-select" disabled>' +
              '<option value="">— D’abord la marque —</option>' +
            '</select>' +
          '</label>' +
          '<label id="oraExTailleField" class="ora-ex-field ora-ex-taille-field" hidden style="margin-top:.75rem">' +
            '<span class="ora-ex-label">Dimension / taille du pneu</span>' +
            '<input id="oraExTaille" class="ora-input" type="text" maxlength="40" autocomplete="off" ' +
            'placeholder="Ex. 70/60-7.5 ou 10 pouces">' +
            '<span class="ora-ex-hint">Vous pouvez indiquer seulement la dimension (sans modèle), si vous la connaissez.</span>' +
          '</label>' +
          '<div class="ora-ex-actions">' +
            '<button type="button" id="oraExVehiculeNext" class="ora-ex-btn">Continuer</button>' +
            '<button type="button" id="oraExUnknown" class="ora-ex-btn-ghost">Je ne trouve pas dans la liste</button>' +
          '</div>' +
          '<p id="oraExVehiculeErr" class="ora-acompte-error" hidden></p>' +
        '</div>' +
        '<div id="oraExStepPosition" class="ora-ex-step" hidden>' +
          '<p class="ora-ex-lead">Position de la pièce.</p>' +
          '<div class="ora-ex-stack">' +
            '<button type="button" class="ora-ex-choice ora-ex-pos" data-value="Avant">Avant</button>' +
            '<button type="button" class="ora-ex-choice ora-ex-pos" data-value="Arrière">Arrière</button>' +
          '</div>' +
        '</div>' +
        '<div id="oraExStepTarif" class="ora-ex-step" hidden>' +
          '<div id="oraExResult" class="ora-ex-result"></div>' +
        '</div>' +
        '<div class="ora-ex-actions"><button type="button" id="oraExBack" class="ora-ex-btn-ghost" hidden>Retour</button></div>';
      welcome.appendChild(box);

      var PREST_CANON = ['Pneu', 'Chambre à air', 'Pneu plein', 'Disque de frein', 'Plaquettes de frein'];
      var prestations = PREST_CANON.slice();
      var prestBtns = box.querySelector('#oraExPrestBtns');
      var prestEmpty = box.querySelector('#oraExPrestEmpty');

      function isPneuFamille_(p) {
        var n = String(p || '').toLowerCase();
        return n.indexOf('pneu') !== -1 || n.indexOf('chambre') !== -1;
      }

      function isDisqueFamille_(p) {
        var n = String(p || '').toLowerCase();
        return n.indexOf('disque') !== -1;
      }

      function selectedPrestations_() {
        var arr = answers.express_prestations;
        if (arr && arr.length) return arr.slice();
        if (answers.express_prestation) {
          return String(answers.express_prestation).split(/\s*\+\s*/).map(function (s) {
            return String(s || '').trim();
          }).filter(Boolean);
        }
        return [];
      }

      function syncPrestLabel_() {
        var sel = selectedPrestations_();
        answers.express_prestation = sel.join(' + ');
        answers.probleme_main = sel.length
          ? mapPrestationToProbleme_(sel[0])
          : (answers.probleme_main || '');
        answers.probleme = answers.probleme_main;
        var btn = document.getElementById('oraExPrestNext');
        if (btn) btn.disabled = !sel.length;
      }

      function estTrottinetteExpress_() {
        var e = String((answers && answers.engin) || '');
        try {
          if (typeof e.normalize === 'function') e = e.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
        } catch (errT) { /* ignore */ }
        e = e.toLowerCase();
        if (!e) return true;
        if (e.indexOf('velo') !== -1 || e.indexOf('vae') !== -1) return false;
        if (e.indexOf('scooter') !== -1) return false;
        return e.indexOf('trott') !== -1;
      }

      /* Aperçu seulement. Le serveur recalcule et ignore ces montants. */
      function appliquerPackMoHistorique_(lignes, pct) {
        lignes = lignes || [];
        pct = (pct == null || pct === '') ? 50 : Number(pct);
        if (!(pct >= 0) || pct > 100) pct = 50;
        if (lignes.length < 2) {
          lignes.forEach(function (l) {
            var mo = Number(l.prix_mo_plein_ttc != null ? l.prix_mo_plein_ttc : l.prix_mo_ttc) || 0;
            l.prix_mo_plein_ttc = Math.round(mo * 100) / 100;
            l.prix_mo_ttc = l.prix_mo_plein_ttc;
            l.mo_pack = 'plein';
            l.total_ttc = Math.round(((Number(l.prix_piece_ttc) || 0) + l.prix_mo_ttc) * 100) / 100;
          });
          return lignes;
        }
        var ord = lignes.map(function (l, i) {
          var mo = Number(l.prix_mo_plein_ttc != null ? l.prix_mo_plein_ttc : l.prix_mo_ttc) || 0;
          return { i: i, mo: mo };
        }).sort(function (a, b) { return b.mo - a.mo; });
        var pleine = ord[0].i;
        var coef = pct / 100;
        lignes.forEach(function (l, idx) {
          var moBase = Number(l.prix_mo_plein_ttc != null ? l.prix_mo_plein_ttc : l.prix_mo_ttc) || 0;
          l.prix_mo_plein_ttc = Math.round(moBase * 100) / 100;
          if (idx === pleine) {
            l.prix_mo_ttc = l.prix_mo_plein_ttc;
            l.mo_pack = 'plein';
          } else {
            l.prix_mo_ttc = Math.round(moBase * coef * 100) / 100;
            l.mo_pack = 'pack_' + pct;
          }
          l.total_ttc = Math.round(((Number(l.prix_piece_ttc) || 0) + l.prix_mo_ttc) * 100) / 100;
        });
        return lignes;
      }

      function appliquerRemiseMoClient_(lignes) {
        lignes = lignes || [];
        if (!estTrottinetteExpress_()) return appliquerPackMoHistorique_(lignes, 50);
        var taux = 20;
        if (cfg && cfg.express && cfg.express.remise_mo_multi_pct != null && cfg.express.remise_mo_multi_pct !== '') {
          taux = Number(cfg.express.remise_mo_multi_pct);
        }
        if (!(taux >= 0) || taux > 100) taux = 20;
        var pleins = lignes.map(function (l) {
          var mo = Number(l.prix_mo_plein_ttc != null ? l.prix_mo_plein_ttc : l.prix_mo_ttc) || 0;
          return Math.round(mo * 100);
        });
        var eligible = 0;
        pleins.forEach(function (c) { eligible += c; });
        var remise = (lignes.length >= 2 && eligible > 0) ? Math.round(eligible * taux / 100) : 0;
        var parts = [];
        var used = 0;
        var i;
        for (i = 0; i < lignes.length; i++) parts.push(0);
        if (remise > 0) {
          var ordre = [];
          for (i = 0; i < lignes.length; i++) {
            var exact = remise * pleins[i] / eligible;
            var base = Math.floor(exact);
            parts[i] = base;
            used += base;
            ordre.push({ i: i, r: exact - base });
          }
          var left = remise - used;
          ordre.sort(function (a, b) {
            if (b.r !== a.r) return b.r - a.r;
            return a.i - b.i;
          });
          var k = 0;
          while (left > 0 && ordre.length) {
            parts[ordre[k % ordre.length].i] += 1;
            left--;
            k++;
          }
        }
        lignes.forEach(function (l, idx) {
          var cut = parts[idx] || 0;
          l.prix_mo_plein_ttc = pleins[idx] / 100;
          l.prix_mo_ttc = (pleins[idx] - cut) / 100;
          l.remise_ligne_montant = cut / 100;
          l.mo_pack = cut > 0 ? 'remise_20' : 'plein';
          l.total_ttc = Math.round(((Number(l.prix_piece_ttc) || 0) + l.prix_mo_ttc) * 100) / 100;
        });
        return lignes;
      }

      function syncTailleUi_() {
        var field = document.getElementById('oraExTailleField');
        var inp = document.getElementById('oraExTaille');
        var label = field && field.querySelector('.ora-ex-label');
        var hint = field && field.querySelector('.ora-ex-hint');
        var prests = selectedPrestations_();
        var showPneu = prests.some(isPneuFamille_);
        var showDisque = prests.some(isDisqueFamille_);
        var show = showPneu || showDisque;
        if (field) field.hidden = !show;
        if (!show) {
          if (inp) inp.value = '';
          answers.express_dimension = '';
          return;
        }
        /* Pneu / chambre : label taille pneu. Disque seul : diamètre mm. */
        if (showDisque && !showPneu) {
          if (label) label.textContent = 'Diamètre du disque (mm)';
          if (inp) inp.placeholder = 'Ex. 140';
          if (hint) {
            hint.textContent =
              'Vous pouvez indiquer seulement le diamètre (sans marque), si vous le connaissez.';
          }
        } else {
          if (label) label.textContent = 'Dimension / taille du pneu';
          if (inp) inp.placeholder = 'Ex. 70/60-7.5 ou 10 pouces';
          if (hint) {
            hint.textContent =
              'Vous pouvez indiquer seulement la dimension (sans modèle), si vous la connaissez.';
          }
        }
      }

      function fillSelect_(sel, placeholder, values, selected) {
        if (!sel) return;
        var cur = selected != null ? selected : sel.value;
        sel.innerHTML = '';
        var o0 = document.createElement('option');
        o0.value = '';
        o0.textContent = placeholder;
        sel.appendChild(o0);
        (values || []).forEach(function (v) {
          var o = document.createElement('option');
          o.value = v;
          o.textContent = v;
          if (cur && cur === v) o.selected = true;
          sel.appendChild(o);
        });
      }

      function renderPrestations_(list) {
        prestBtns.innerHTML = '';
        var items = (list && list.length) ? list : PREST_CANON;
        if (prestEmpty) prestEmpty.hidden = !(list && list.length === 0);
        if (!answers.express_prestations) answers.express_prestations = [];
        items.forEach(function (p) {
          var b = document.createElement('button');
          b.type = 'button';
          b.className = 'ora-ex-choice';
          b.textContent = p;
          b.setAttribute('data-value', p);
          b.setAttribute('aria-pressed', answers.express_prestations.indexOf(p) !== -1 ? 'true' : 'false');
          if (answers.express_prestations.indexOf(p) !== -1) b.classList.add('ora-selected');
          b.addEventListener('click', function () {
            var cur = answers.express_prestations || [];
            var ix = cur.indexOf(p);
            if (ix === -1) cur.push(p);
            else cur.splice(ix, 1);
            answers.express_prestations = cur;
            b.setAttribute('aria-pressed', ix === -1 ? 'true' : 'false');
            b.classList.toggle('ora-selected', ix === -1);
            syncPrestLabel_();
            syncTailleUi_();
            persistDraft_();
          });
          prestBtns.appendChild(b);
        });
        syncPrestLabel_();
      }
      window.__oraExpressRenderPrestations = renderPrestations_;
      renderPrestations_(
        (cfg && cfg.express && cfg.express.prestations && cfg.express.prestations.length)
          ? cfg.express.prestations
          : PREST_CANON
      );

      var exOrder = [];
      var modelesSuggestKey_ = '';
      var marquesFetchId_ = 0;

      function showMarquesHint_(msg) {
        var err = document.getElementById('oraExVehiculeErr');
        if (!err) return;
        if (!msg) { err.hidden = true; err.textContent = ''; return; }
        err.hidden = false;
        err.textContent = msg;
      }

      function prefetchMarques_() {
        var selM = document.getElementById('oraExMarque');
        var selMod = document.getElementById('oraExModele');
        if (!api.getExpressMarques) {
          fillSelect_(selM, '— Catalogue indisponible —', []);
          showMarquesHint_('API Express indisponible.');
          return;
        }
        var fetchId = ++marquesFetchId_;
        if (selM) fillSelect_(selM, 'Chargement…', []);
        showMarquesHint_('');

        function applyMarques_(marques, fromCache) {
          if (fetchId !== marquesFetchId_) return;
          marques = marques || [];
          fillSelect_(selM, marques.length ? '— Choisir la marque —' : '— Aucune marque validée —', marques);
          if (selMod) {
            selMod.disabled = true;
            fillSelect_(selMod, '— D’abord la marque —', []);
          }
          if (marques.length) {
            try { sessionStorage.setItem('ora_ex_marques', JSON.stringify(marques)); } catch (e) {}
            showMarquesHint_('');
            return;
          }
          var apiUrl = (api.config && api.config.apiUrl) || '';
          showMarquesHint_(
            'Aucune marque reçue' + (fromCache ? ' (cache local)' : '') +
            '. Recolle oratelier-repair-api.js et vérifie l’URL Site Write. Actuel : ' +
            (apiUrl || '—')
          );
        }

        api.getExpressMarques().then(function (r) {
          if (fetchId !== marquesFetchId_) return;
          if (!r || r.success === false) {
            /* Fallback sessionStorage si réseau KO */
            try {
              var cached = JSON.parse(sessionStorage.getItem('ora_ex_marques') || '[]');
              if (cached && cached.length) {
                applyMarques_(cached, true);
                return;
              }
            } catch (e2) { /* ignore */ }
            fillSelect_(selM, '— Erreur de chargement —', []);
            showMarquesHint_('Impossible de charger les marques. Cmd+Option+I → Réseau → express_marques.');
            return;
          }
          /* Ne pas écraser une bonne liste avec un tableau vide */
          var marques = r.marques || [];
          if (!marques.length) {
            try {
              var prev = JSON.parse(sessionStorage.getItem('ora_ex_marques') || '[]');
              if (prev && prev.length) {
                applyMarques_(prev, true);
                return;
              }
            } catch (e3) { /* ignore */ }
          }
          applyMarques_(marques, false);
        });
      }

      function prefetchModeles_() {
        var selM = document.getElementById('oraExMarque');
        var selMod = document.getElementById('oraExModele');
        var marque = selM ? selM.value : '';
        var sels = selectedPrestations_();
        var prest = sels.length === 1 ? sels[0] : '';
        var key = marque.toLowerCase() + '|' + (sels.join('+')).toLowerCase();
        if (!marque) {
          if (selMod) {
            selMod.disabled = true;
            fillSelect_(selMod, '— D’abord la marque —', []);
          }
          return;
        }
        if (!api.getExpressModeles) return;
        if (key === modelesSuggestKey_ && selMod && selMod.options.length > 1) return;
        if (selMod) {
          selMod.disabled = true;
          fillSelect_(selMod, 'Chargement…', []);
        }
        api.getExpressModeles(marque, prest).then(function (r) {
          modelesSuggestKey_ = key;
          var modeles = (r && r.modeles ? r.modeles : []).map(function (x) { return x.modele; });
          if (selMod) {
            selMod.disabled = false;
            fillSelect_(selMod, modeles.length ? '— Choisir le modèle —' : '— Aucun modèle —', modeles);
          }
        });
      }

      function needsPosition_() {
        return selectedPrestations_().some(function (prest) {
          var p = String(prest || '').toLowerCase();
          return p.indexOf('pneu') !== -1 || p.indexOf('chambre') !== -1 ||
            p.indexOf('plaquette') !== -1 || p.indexOf('disque') !== -1 || p.indexOf('frein') !== -1;
        });
      }
      function rebuildExOrder_() {
        exOrder = ['prestation', 'vehicule'];
        if (needsPosition_()) exOrder.push('position');
        exOrder.push('tarif');
      }
      var exStepIds = {
        prestation: 'oraExStepPrestation',
        vehicule: 'oraExStepVehicule',
        position: 'oraExStepPosition',
        tarif: 'oraExStepTarif'
      };
      var exCurrent = 'prestation';

      function showExStep_(key) {
        exCurrent = key;
        rebuildExOrder_();
        var idx = exOrder.indexOf(key);
        var prog = document.getElementById('oraExProgress');
        if (prog) {
          prog.textContent = idx >= 0
            ? ('Express — étape ' + (idx + 1) + ' sur ' + exOrder.length)
            : 'Réparation Express';
        }
        Object.keys(exStepIds).forEach(function (k) {
          var el = document.getElementById(exStepIds[k]);
          if (el) el.hidden = (k !== key);
        });
        var back = document.getElementById('oraExBack');
        if (back) back.hidden = (key === 'prestation');
        if (key === 'vehicule') syncTailleUi_();
      }

      function goExStep_(key) {
        showExStep_(key);
        if (key === 'vehicule') {
          prefetchMarques_();
        }
        persistDraft_();
      }

      function basculerClassique(msg) {
        answers.express = false;
        answers.flow_type = 'standard';
        answers.express_compat_id = '';
        answers.express_lignes = [];
        answers.probleme_main = answers.probleme_main || 'Autre problème';
        answers.probleme = answers.probleme_main;
        ensureUrgenceDefault_();
        setCoach(msg || 'Modèle libre noté. Poursuivons avec le formulaire classique.', 'info');
        box.hidden = true;
        openFunnel();
      }

      function appliquerTarifOk_(lignes, marque, modele, position) {
        lignes = appliquerRemiseMoClient_(lignes || []);
        answers.express = true;
        answers.flow_type = 'express';
        answers.express_position = position || (lignes[0] && lignes[0].position) || '';
        answers.express_lignes = lignes.map(function (l) {
          return {
            compat_id: l.compat_id || '',
            prestation: l.prestation || '',
            position: l.position || position || '',
            piece: l.piece || '',
            prix_piece_ttc: l.prix_piece_ttc,
            prix_mo_ttc: l.prix_mo_ttc,
            prix_mo_plein_ttc: l.prix_mo_plein_ttc,
            total_ttc: l.total_ttc,
            mo_pack: l.mo_pack || ''
          };
        });
        var first = lignes[0] || {};
        answers.express_compat_id = first.compat_id || '';
        answers.express_marque = marque;
        answers.express_piece = lignes.map(function (l) { return l.piece; }).filter(Boolean).join(' · ');
        var totP = 0, totM = 0, tot = 0;
        lignes.forEach(function (l) {
          totP += Number(l.prix_piece_ttc) || 0;
          totM += Number(l.prix_mo_ttc) || 0;
          tot += Number(l.total_ttc) || 0;
        });
        answers.express_prix_piece = Math.round(totP * 100) / 100;
        answers.express_prix_mo = Math.round(totM * 100) / 100;
        answers.express_total = Math.round(tot * 100) / 100;
        syncPrestLabel_();
        answers.modele = (marque + ' ' + modele).trim() ||
          ((first.marque || '') + ' ' + (first.modele || '')).trim();
        answers.engin = answers.engin || 'Trottinette électrique';
        ensureUrgenceDefault_();
      }

      function lireVehicule_() {
        var selM = document.getElementById('oraExMarque');
        var selMod = document.getElementById('oraExModele');
        var marque = selM ? String(selM.value || '').trim() : '';
        var modele = selMod ? String(selMod.value || '').trim() : '';
        var taille = '';
        var tailleWrap = document.getElementById('oraExTailleField');
        var tailleEl = document.getElementById('oraExTaille');
        if (tailleEl && tailleWrap && !tailleWrap.hidden) {
          taille = (tailleEl.value || '').trim();
        }
        return { marque: marque, modele: modele, dimension: taille };
      }

      function lancerEstimation_() {
        var v = lireVehicule_();
        var marque = v.marque;
        var modele = v.modele;
        var dimension = v.dimension || answers.express_dimension || '';
        var prests = selectedPrestations_();
        var position = answers.express_position || '';
        answers.express_dimension = dimension;
        var res = document.getElementById('oraExResult');
        if (res) res.innerHTML = '<p class="ora-ex-lead">Recherche de compatibilité…</p>';
        goExStep_('tarif');
        if (!api.estimateExpress) {
          if (res) res.textContent = 'Estimation indisponible. Vous pouvez continuer en parcours classique.';
          return;
        }
        if (!prests.length) {
          if (res) res.innerHTML = '<p class="ora-ex-lead">Choisissez au moins une pièce.</p>';
          goExStep_('prestation');
          return;
        }
        Promise.all(prests.map(function (prest) {
          return api.estimateExpress(marque, modele, prest, position, dimension).then(function (r) {
            return { prestation: prest, r: r };
          });
        })).then(function (results) {
          var ok = [];
          var miss = [];
          results.forEach(function (row) {
            var r = row.r;
            if (r && r.found) {
              ok.push({
                compat_id: r.compat_id || '',
                prestation: row.prestation || r.prestation || '',
                position: position || r.position || '',
                piece: r.piece || '',
                marque: r.marque || marque,
                modele: r.modele || modele,
                prix_piece_ttc: r.prix_piece_ttc,
                prix_mo_ttc: r.prix_mo_ttc,
                total_ttc: r.total_ttc
              });
            } else {
              miss.push(row.prestation);
            }
          });
          if (!ok.length) {
            answers.modele = (marque + ' ' + modele).trim();
            answers.express_marque = marque;
            answers.express = false;
            answers.flow_type = 'standard';
            answers.express_compat_id = '';
            answers.express_lignes = [];
            if (res) {
              res.innerHTML =
                '<p>Modèle non répertorié pour ' + escapeHtml(miss.join(', ') || 'cette sélection') + '.</p>' +
                '<p class="ora-ex-lead">Seules les pièces validées Express sont proposées. Vérifiez la liste, ou continuez en classique.</p>' +
                '<p class="ora-ex-actions"><button type="button" id="oraExFallbackStd" class="ora-ex-btn">Continuer la demande</button></p>';
              var fb = document.getElementById('oraExFallbackStd');
              if (fb) fb.addEventListener('click', function () {
                basculerClassique('Poursuite en parcours classique.');
              });
            }
            return;
          }
          appliquerTarifOk_(ok, marque || ok[0].marque || '', modele || ok[0].modele || '', position);
          if (res) {
            var html = '<p><strong>Compatibilité trouvée</strong></p>' +
              '<p>' + escapeHtml((ok[0].marque || marque) + ' ' + (ok[0].modele || modele)) + '</p>';
            var economise = 0;
            answers.express_lignes.forEach(function (l) {
              var packNote = (l.mo_pack && String(l.mo_pack).indexOf('pack') === 0)
                ? ' <span class="ora-ex-hint">(pack)</span>'
                : (String(l.mo_pack || '').indexOf('remise_20') === 0
                  ? ' <span class="ora-ex-hint">(remise −20&nbsp;%)</span>' : '');
              var plein = Number(l.prix_mo_plein_ttc);
              var mo = Number(l.prix_mo_ttc);
              if (isFinite(plein) && isFinite(mo)) economise += (plein - mo);
              html += '<p>' + escapeHtml(l.prestation || 'Ligne') +
                ' — pièce ' + escapeHtml(String(l.prix_piece_ttc)) +
                ' € · MO ' + escapeHtml(String(l.prix_mo_ttc)) + ' €' + packNote +
                ' · <strong>' + escapeHtml(String(l.total_ttc)) + ' €</strong></p>';
            });
            economise = Math.round(economise * 100) / 100;
            if (miss.length) {
              html += '<p class="ora-ex-hint">Non trouvé : ' + escapeHtml(miss.join(', ')) + ' — l’atelier vérifiera.</p>';
            }
            if (economise > 0) {
              html += '<p><strong>Remise multi-prestations −20 % sur la main-d’œuvre</strong> : −' +
                escapeHtml(String(economise)) + ' €</p>';
            }
            html +=
              '<p><strong>' + (economise > 0 ? 'Total après remise ' : 'Total estimation ') +
              escapeHtml(String(answers.express_total)) + ' € TTC</strong></p>' +
              '<p class="ora-ex-lead">Estimation — le tarif définitif est confirmé par l’atelier à l’enregistrement.</p>' +
              '<p class="ora-ex-actions"><button type="button" id="oraExContinue" class="ora-ex-btn">Continuer</button></p>';
            res.innerHTML = html;
            var go = document.getElementById('oraExContinue');
            if (go) go.addEventListener('click', function () {
              box.hidden = true;
              openFunnelAtKey_('prise');
            });
          }
        }).catch(function () {
          if (res) {
            res.innerHTML =
              '<p>Estimation indisponible pour le moment.</p>' +
              '<p class="ora-ex-actions"><button type="button" id="oraExFallbackStd2" class="ora-ex-btn">Continuer la demande</button></p>';
            var fb2 = document.getElementById('oraExFallbackStd2');
            if (fb2) fb2.addEventListener('click', function () {
              answers.modele = (marque + ' ' + modele).trim();
              basculerClassique('Poursuite en parcours classique.');
            });
          }
        });
      }

      document.getElementById('oraExpressOpen').addEventListener('click', function () {
        answers.express = true;
        answers.flow_type = 'express';
        choice.hidden = true;
        box.hidden = false;
        prefetchMarques_();
        showExStep_('prestation');
        trackEvent('repair_express_start', { source: 'path_choice' });
      });

      /* Précharge dès l’accueil (pendant que le client lit) → liste instantanée ensuite */
      if (api.getExpressCatalog) {
        api.getExpressCatalog(false);
      } else {
        prefetchMarques_();
      }
      var stdBtn = document.getElementById('oraStandardOpen');
      if (stdBtn) stdBtn.addEventListener('click', function () {
        answers.express = false;
        answers.flow_type = 'standard';
        choice.hidden = true;
        openFunnel();
      });

      var selMarque = document.getElementById('oraExMarque');
      if (selMarque) {
        selMarque.addEventListener('change', function () {
          modelesSuggestKey_ = '';
          prefetchModeles_();
        });
      }

            var prestNext = document.getElementById('oraExPrestNext');
      if (prestNext) {
        prestNext.addEventListener('click', function () {
          if (!selectedPrestations_().length) return;
          syncPrestLabel_();
          goExStep_('vehicule');
          syncTailleUi_();
        });
      }

document.getElementById('oraExVehiculeNext').addEventListener('click', function () {
        var err = document.getElementById('oraExVehiculeErr');
        var v = lireVehicule_();
        if (!v.marque && !v.dimension) {
          if (err) { err.hidden = false; err.textContent = 'Choisissez une marque, ou indiquez la dimension.'; }
          return;
        }
        if (!v.modele && !v.dimension) {
          if (err) { err.hidden = false; err.textContent = 'Choisissez un modèle, ou indiquez la dimension.'; }
          return;
        }
        if (err) err.hidden = true;
        answers.express_marque = sanitizeInput(v.marque);
        answers.modele = sanitizeInput((v.marque + ' ' + (v.modele || '')).trim());
        answers.express_dimension = sanitizeInput(v.dimension || '');
        if (needsPosition_()) {
          answers.express_position = '';
          goExStep_('position');
        } else {
          answers.express_position = '';
          lancerEstimation_();
        }
      });

      box.querySelector('#oraExUnknown').addEventListener('click', function () {
        var v = lireVehicule_();
        answers.express_marque = v.marque;
        answers.modele = (v.marque + ' ' + v.modele).trim();
        answers.express_dimension = v.dimension || '';
        basculerClassique('Modèle libre noté. La compatibilité sera vérifiée par l’atelier.');
      });

      box.querySelectorAll('.ora-ex-pos').forEach(function (btn) {
        btn.addEventListener('click', function () {
          answers.express_position = btn.getAttribute('data-value') || '';
          lancerEstimation_();
        });
      });

      document.getElementById('oraExBack').addEventListener('click', function () {
        rebuildExOrder_();
        var idx = exOrder.indexOf(exCurrent);
        if (idx <= 0) {
          box.hidden = true;
          choice.hidden = false;
          showExStep_('prestation');
          return;
        }
        goExStep_(exOrder[idx - 1]);
      });
    }

    /* Afficher le choix de parcours tout de suite, puis rafraîchir les prestations API */
    bootExpress_({ express: { express_enabled: true, prestations: [] } });
    if (api.getConfig) {
      api.getConfig().then(function (cfg) {
        if (typeof appliquerConfigRdv_ === 'function') appliquerConfigRdv_(cfg);
        var list = cfg && cfg.express && cfg.express.prestations;
        if (!list || !list.length) return;
        if (typeof window.__oraExpressRenderPrestations === 'function') {
          window.__oraExpressRenderPrestations(list);
        }
      }).catch(function () { /* ignore */ });
    }
  }

  function applyDraftToInputs_() {
    ensureNomField_();
    var map = [
      ['oraPrenomInput', 'prenom'],
      ['oraNomInput', 'nom'],
      ['oraPhoneInput', 'phone'],
      ['oraEmailInput', 'email'],
      ['oraAddressLine', 'address_line'],
      ['oraZip', 'zip'],
      ['oraCity', 'city']
    ];
    map.forEach(function (pair) {
      var el = document.getElementById(pair[0]);
      if (el && answers[pair[1]]) el.value = answers[pair[1]];
    });
    var cb = document.getElementById('oraAcompteAccept');
    if (cb) cb.checked = false;
  }

  function offerDraftRestore_() {
    var api = window.OraRepairApi;
    if (!api || !api.loadDraft) return;
    var draft = null;
    try { draft = api.loadDraft(); } catch (e) { draft = null; }
    if (!draft || !draft.answers || draftRestored) return;
    var welcome = document.getElementById('oraWelcome');
    if (!welcome || document.getElementById('oraDraftBanner')) return;
    var banner = document.createElement('div');
    banner.id = 'oraDraftBanner';
    banner.style.cssText = 'margin:0.85rem 0;padding:0.85rem 1rem;border-left:3px solid #E86A33;background:rgba(232,106,51,.08);border-radius:0 10px 10px 0;';
    banner.innerHTML =
      '<p style="margin:0 0 .55rem;font-size:.95rem">Une demande en cours a été trouvée sur cet appareil.</p>' +
      '<button type="button" id="oraDraftResume" style="margin-right:.4rem">Reprendre</button>' +
      '<button type="button" id="oraDraftDiscard">Recommencer</button>';
    welcome.insertBefore(banner, welcome.firstChild);
    document.getElementById('oraDraftResume').addEventListener('click', function () {
      answers = draft.answers || {};
      ensureUrgenceDefault_();
      draftRestored = true;
      applyDraftToInputs_();
      for (var k in answers) {
        if (Object.prototype.hasOwnProperty.call(answers, k)) syncPersistedStepOptions(0);
      }
      steps.forEach(function (_s, idx) { syncPersistedStepOptions(idx); });
      banner.remove();
      openFunnel();
      var step = typeof draft.step === 'number' ? draft.step : 0;
      if (step > 0 && step < steps.length) showStep(Math.min(step, steps.length - 1));
      var cb = document.getElementById('oraAcompteAccept');
      if (cb) cb.checked = false;
      persistDraft_();
    });
    document.getElementById('oraDraftDiscard').addEventListener('click', function () {
      if (api.clearDraft) api.clearDraft();
      banner.remove();
    });
  }

  /* Liens de la page Prestations & tarifs :
     /?ora_engin=trottinette|velo&ora_cat=pneu|frein|batterie|electronique|autre&ora_presta=…#oraFormMain
     Ancre réelle : #oraFormMain. Paramètres inconnus ignorés. Aucun envoi. */
  var ORA_TARIF_LINKS = {
    'pneu-tubeless': { engin: 'trottinette', cat: 'pneu', label: 'Changement de pneu tubeless', chips: [{ field: 'pneu_type', value: 'Tubeless' }] },
    'pneu-chambre': { engin: 'trottinette', cat: 'pneu', label: 'Changement de pneu à chambre à air', chips: [{ field: 'pneu_type', value: 'Chambre à air' }] },
    'pneu-et-chambre': { engin: 'trottinette', cat: 'pneu', label: 'Changement de pneu + chambre à air', chips: [{ field: 'pneu_type', value: 'Chambre à air' }] },
    'pneu-plein': { engin: 'trottinette', cat: 'pneu', label: 'Changement de pneu plein', chips: [{ field: 'pneu_type', value: 'Pneu plein' }] },
    'plaquettes': { engin: 'trottinette', cat: 'frein', label: 'Changement de plaquettes' },
    'disque': { engin: 'trottinette', cat: 'frein', label: 'Changement de disque' },
    'batterie': { engin: 'trottinette', cat: 'batterie', label: 'Changement de batterie' },
    'controleur': { engin: 'trottinette', cat: 'electronique', label: 'Changement de contrôleur' },
    'accessoire': { engin: 'trottinette', cat: 'autre', label: 'Changement d’accessoire' },
    'diagnostic': { engin: 'trottinette', cat: 'autre', label: 'Diagnostic global trottinette' },
    'vae-pneu-classique': { engin: 'velo', cat: 'pneu', label: 'Pneu ou chambre à air sur roue classique (VAE)', chips: [{ field: 'motor', value: 'Non' }] },
    'vae-pneu-moteur': { engin: 'velo', cat: 'pneu', label: 'Pneu ou chambre à air sur roue motorisée (VAE)', chips: [{ field: 'motor', value: 'Oui' }] },
    'vae-pneu-tubeless': { engin: 'velo', cat: 'pneu', label: 'Changement de pneu tubeless (VAE)', chips: [{ field: 'pneu_type', value: 'Tubeless' }] },
    'vae-plaquettes': { engin: 'velo', cat: 'frein', label: 'Changement de plaquettes (VAE)' },
    'vae-disque': { engin: 'velo', cat: 'frein', label: 'Changement de disque (VAE)' },
    'vae-batterie': { engin: 'velo', cat: 'batterie', label: 'Changement de batterie sans adaptation (VAE)' },
    'vae-controleur': { engin: 'velo', cat: 'electronique', label: 'Changement de contrôleur compatible (VAE)' },
    'vae-accessoire': { engin: 'velo', cat: 'autre', label: 'Montage d’accessoire simple (VAE)' },
    'vae-diagnostic': { engin: 'velo', cat: 'autre', label: 'Diagnostic global VAE' }
  };

  function markEngin_(label) {
    if (!label || allowedValues.engin.indexOf(label) === -1) return;
    answers.engin = label;
    var step = null;
    for (var i = 0; i < steps.length; i++) {
      if (stepKey_(steps[i]) === 'engin') { step = steps[i]; break; }
    }
    if (!step) return;
    var opts = step.querySelectorAll('.ora-option[data-value]');
    for (var j = 0; j < opts.length; j++) {
      var on = opts[j].getAttribute('data-value') === label;
      opts[j].classList.toggle('ora-selected', on);
      opts[j].setAttribute('aria-pressed', on ? 'true' : 'false');
    }
    step.classList.add('ora-complete');
    updateLivePath();
  }

  function selectTarifChip_(catLabel, field, value) {
    var allowedFields = { roue: 1, motor: 1, pneu_type: 1, frein_roue: 1, frein_symptome: 1, frein_type: 1 };
    if (!allowedFields[field] || !value) return;
    var panel = detailPanels[catLabel];
    if (!panel) return;
    var group = panel.querySelector('.ora-chips[data-field="' + field + '"]');
    if (!group) return;
    var chips = group.querySelectorAll('.ora-chip');
    var found = false;
    for (var i = 0; i < chips.length; i++) {
      var on = chips[i].getAttribute('data-value') === value;
      chips[i].classList.toggle('ora-chip-on', on);
      chips[i].setAttribute('aria-pressed', on ? 'true' : 'false');
      if (on) found = true;
    }
    if (!found) return;
    if (!answers.probleme_precision) answers.probleme_precision = {};
    answers.probleme_precision[field] = value;
  }

  function prefillPrestaNote_(catLabel, label) {
    var ids = {
      'Pneu / crevaison': 'oraNotePneu',
      'Freinage': 'oraNoteFrein',
      'Batterie / autonomie': 'oraNoteBat',
      'Électronique': 'oraNoteElec',
      'Autre problème': 'oraNoteAutre'
    };
    var el = document.getElementById(ids[catLabel] || '');
    if (!el || el.value) return;
    var text = 'Prestation souhaitée : ' + label + '.';
    if (text.length > 200) text = text.slice(0, 200);
    el.value = text;
    try { el.dispatchEvent(new Event('input', { bubbles: true })); } catch (eNote) {}
  }

  function applyTarifIntent_() {
    var params = null;
    try { params = new URLSearchParams(window.location.search); } catch (eParams) { return; }
    var hash = window.location.hash || '';
    var prestaKey = String(params.get('ora_presta') || '');
    var intent = Object.prototype.hasOwnProperty.call(ORA_TARIF_LINKS, prestaKey) ? ORA_TARIF_LINKS[prestaKey] : null;
    var enginMap = { trottinette: 'Trottinette électrique', velo: 'Vélo électrique' };
    var catMap = {
      pneu: 'Pneu / crevaison',
      frein: 'Freinage',
      freinage: 'Freinage',
      batterie: 'Batterie / autonomie',
      electronique: 'Électronique',
      controleur: 'Électronique',
      autre: 'Autre problème',
      accessoire: 'Autre problème',
      diagnostic: 'Autre problème'
    };
    var enginLabel = intent ? enginMap[intent.engin] : enginMap[String(params.get('ora_engin') || '').toLowerCase()];
    var catLabel = intent ? catMap[intent.cat] : catMap[String(params.get('ora_cat') || '').toLowerCase()];
    if (hash !== '#oraFormMain' && !enginLabel && !catLabel) return;
    answers.express = false;
    answers.flow_type = 'standard';
    if (!funnelActive) openFunnel();
    if (enginLabel) markEngin_(enginLabel);
    if (catLabel) onSelectProblemeMain(catLabel);
    if (intent && intent.chips && catLabel) {
      for (var c = 0; c < intent.chips.length; c++) {
        selectTarifChip_(catLabel, intent.chips[c].field, intent.chips[c].value);
      }
    }
    if (intent && catLabel) {
      answers.prestation_demandee = intent.label;
      prefillPrestaNote_(catLabel, intent.label);
    }
    if (enginLabel || catLabel) {
      var idx = stepIndexByKeyName_('probleme');
      if (idx >= 0) showStep(idx);
    }
  }

  removeUrgenceStep_();
  initExpress();
  offerDraftRestore_();
  ensureNomField_();
  showStep(0);
  updateContactRequirements();
  updateProblemeContinueState();
  applyTarifIntent_();
})();
